import React, { useEffect, useMemo, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import ClearIcon from "@material-ui/icons/Clear";
import BlockIcon from "@mui/icons-material/Block";
import SendIcon from '@mui/icons-material/Send';
import Inventory2Icon from "@mui/icons-material/Inventory2";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";
import getUserdetailsforsubscrption from "../../dashboard/actions/dashboardaapi";
import DatePicker, { DateObject } from "react-multi-date-picker";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { SpinnerRoundFilled } from "spinners-react";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "react-loader-spinner";
import '../style/style.css';
import { trim } from "lodash";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TrendingUpIcon from "@mui/icons-material/TrendingUp"
import PaymentIcon from "@mui/icons-material/Payment"
import {
  Grid,
  Popover,
  Button,
  InputLabel,
  FormControl,
  Input,
  Typography,
  FormHelperText,
  Modal,
  Box,
  Select,
  MenuItem,
  TextField,
  TableSortLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import Slider, { SliderValueLabel } from '@mui/material/Slider';
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import {
  invoiceDashboard,
  updatePaymentStatus,
  updatePaymentStatusMultiple,
  getPaymentHistory,
  downloadInvoice,
  alldownloadInvoice,
  searchProductsAPI,
  profitModal
} from "./../../dealer/actions/dealerAction";
import { getModelSerialList, invoiceDataPush } from "../actions/dashboardAction";
import { connect } from "react-redux";
import { Link } from "@material-ui/core";
import InvoiceTransactionModal from "./invoiceModal";
import ShippingInfoUpdateModal from "./shippingInfoUpdateModal";
//import { Container, Grid, Typography, Card} from '@material-ui/core';
import FormLabel from "@mui/material/FormLabel";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import PropTypes, { any } from "prop-types";
import { StyledEngineProvider } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelInvoiceModal from "./CancelInvoiceModal";
import ProfitModal from "./profitModal";
import QboConfig from "./QboConfig";
import QboInvoice from "./QboInvoice";
import ViewInvoicemodel from "./ViewInvoicemodel";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { makeStyles } from "@material-ui/core/styles";
import { formatDate, getComponentActionList, isActionAllowed, showErrorToast, showSuccessToast } from "../../../../common/components/Helper/Utils";
import ContentWrapper from '../../../../common/components/contentWrapper';
import UpgradePlan from "../../common/components/upgradePlan";
import { useLocation } from "react-router-dom";
import MemoHistoryModal from "./memoHistoryModal";
import { CircleArrow as ScrollUpButton } from "react-scroll-up-button";
import CloseIcon from "@material-ui/icons/Close";
import { useHistory } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";
import amountFormatter from "../../common/components/amountFormat";
import { LocalMallOutlined } from "@material-ui/icons";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: 600,
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const followersMarks1 = [
  {
    value: 0,
    scaledValue: 1,
    label: "ALL",
  },
  {
    value: 30,
    scaledValue: 2,
    label: "30 d",
  },
  {
    value: 60,
    scaledValue: 4,
    label: "60 d",
  },
  {
    value: 90,
    scaledValue: 6,
    label: "90 d",
  },
  {
    value: 120,
    scaledValue: 8,
    label: "120 d",
  },
  {
    value: 150,
    scaledValue: 9,
    label: "150 d",
  },
  {
    value: 180,
    scaledValue: 10,
    label: "180 d",
  },
];
const AmountRangeObj = [
  {
    value: "0",
    scaledValue: 0,
    label: "0",
  },
  {
    value: 5000,
    scaledValue: 2,
    label: "$5k",
  },
  {
    value: 10000,
    scaledValue: 3,
    label: "$ 10k",
  },
  {
    value: 25000,
    scaledValue: 4,
    label: "$ 25k",
  },
  {
    value: 50000,
    scaledValue: 6,
    label: "$ 50k",
  },
  {
    value: 75000,
    scaledValue: 8,
    label: "$ 75k",
  },
  {
    value: 100001,
    scaledValue: 10,
    label: "$ 100k+",
  },
];
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const useStyles = makeStyles((theme) => ({
  sortIcon: {
    fontSize: "1rem",
    verticalAlign: "middle",
    cursor: "pointer",
  },
}));
const columns = [
  { id: "invoicenumber", label: "Invoice #", minWidth: 100 },
  { id: "invoicetype", label: "Invoice Type", minWidth: 100 },
  { id: "invoicedate", label: "Date", minWidth: 70 },
  { id: "solddate", label: "Sold Date", minWidth: 70 },
  { id: "createdby", label: "Created By", minWidth: 100 },

  {
    id: "contactname",
    label: "Customer Name",
    minWidth: 100,
  },
  {
    id: "businessname",
    label: "Business Name",
    minWidth: 100,
  },
  {
    id: "totalprice",
    label: "Invoice Amount ($)",
    minWidth: 100,
  },
  {
    id: "trackingnumber",
    label: "Tracking Number",
    minWidth: 100,
  },
  // {
  //   id: "shippingmethod",
  //   label: "Shipping Method",
  //   minWidth: 100,
  // },
  {
    id: "paymentstatus",
    label: "Payment Status",
    minWidth: 100,
  },
  {
    id: "paymentdate",
    label: "Payment Date",
    minWidth: 80,
  },
  {
    id: "memo_returndate",
    label: "Memo Return Date",
    minWidth: 80,
  },
  {
    id: "remainingbalance",
    label: "Balance",
    minWidth: 100,
  },
  {
    id: "status",
    label: "Invoice Status",
    minWidth: 100,
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 80,
  },
];
const payBackPaymentMethods = ["Affirm", "Cash", "Check", "Crypto", "Paypal", "Venmo", "Wire", "Zelle"]

const sortFieldMap = {
  invoicenumber: "invoiceNo",
  invoicetype: "invoiceType",
  invoicedate: "invoiceDate",
  solddate: "soldDate",
  createdby: "createdBy",
  contactname: "customerName",
  businessname: "businessName",
  totalprice: "invoiceAmount",
  trackingnumber: "trackingNo",
  paymentstatus: "paymentStatus",
  paymentdate: "paymentDate",
  memo_returndate: "memoReturnDate",
  remainingbalance: "balance",
  status: "invoiceStatus",
  profit: "profit",
};

const CustomFooter = ({ setInvoiceDateRange }) => {
  const handleDateRangeSelection = (months) => {
    const endDate = new DateObject();
    const startDate = new DateObject().subtract(months, "months");
    setInvoiceDateRange([startDate, endDate]);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "15px", gap: "8px", }}>
      <button id="clearBtn" onClick={() => handleDateRangeSelection(1)}>Last 1 Month</button>
      <button id="clearBtn" onClick={() => handleDateRangeSelection(3)}>Last 3 Months</button>
      <button id="clearBtn" onClick={() => handleDateRangeSelection(6)}>Last 6 Months</button>
    </div>
  );
};

const InvoiceDashboardList = (props) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
    reset,
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    setValue: setValue1,
    getValues: getValues1,
    formState: { errors: errors1 },
    watch: watch1,
    reset: reset1,
  } = useForm();
  // const orderby = '';
  const location = useLocation();
  const { invoiceFilter, deposit } = location.state || {};
  const [pageNo, setpageNo] = useState(1);
  const [limit, setLimit] = useState(20);
  const [rows, setRows] = React.useState([]);
  const [openModal, setModalOpen] = useState(false);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [invoiceType, setInvoiceType] = useState("regular_invoice");
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [amount, setAmount] = useState("");
  const [disableAmount, setDisableAmount] = useState(false);
  const [paymentDate, setPaymentdDate] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [remainingAmount, setRemainingAmount] = useState(null);
  const [errRemainingAmt, setRemaingAmtError] = useState(null);
  const [remainingBalance, setRemainingBalance] = useState(null);
  const [totalAmt, setTotalAmt] = useState(null);
  const [invoiceId, setInvoiceId] = useState(null);
  // const [qboInvoiceId, setQboInvoiceId] = useState(null);
  const [accountIds, setAccountId] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [formInvalid, setFormInvalid] = useState(false);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("OpenInvoices");
  const [inventoryTypeFilter, setinventoryTypeFilter] = useState(null);
  const [invoiceTypeFilter, setinvoiceTypeFilter] = useState(invoiceFilter?.type || "invoice");
  const [memoInvoiceStatusFilter, setmemoInvoiceStatusFilter] = useState(invoiceFilter?.memoInvoiceStatus || "All");
  //const [invoiceList, setInvoiceList] = useState([]);
  const [serialNo, setSerialNo] = useState(null);
  const [paymentdetails, setPaymentDetails] = useState(null);
  const [model, setModelList] = useState(props?.modelList);
  const [modelNo, setModel] = useState(null);
  const [description, setDescription] = useState(null);
  const [searchObj, setSearchObj] = useState({});
  const userDetails = sessionStorage.getItem("userDetails") ? JSON.parse(sessionStorage.getItem("userDetails")) : null;
  const [anchorEl, setAnchorEl] = useState(null);
  const [noData, setNoData] = useState(false);
  const [anchorTarget, setAnchorTarget] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [modelErrorText, setModelErrorText] = useState("");
  const [paymentMethodErrorText, setPaymentMethodErrorText] = useState("");
  const [PDF, setPDF] = useState(null);
  const [serialnoErrorText, setSerialNoErrorText] = useState("");
  const [openInvoiceTransactionModal, setOpenInvoiceTransactionModal] =
    useState(false);
  const [openShippingInfoModal, setOpenShippingInfoModal] = useState(false);
  const [openQBOConfigModal, setOpenQBOConfigModal] = useState(false);
  const [openQBOInvoiceModal, setOpenQBOInvoiceModal] = useState(false);
  const [dealerPushConfirmOpen, setDealerPushConfirmOpen] = useState(false);
  const [createdInvoiceId, setCreatedInvoiceId] = useState(null);
  const [createdInvoiceType, setCreatedInvoiceType] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [invoiceDateInterval, setInvoiceDateInterval] = useState('ALL');
  const [openCancelModal, setCancelModal] = useState(false);
  const [openProfitModal, setOpenProfitModal] = useState(false);
  const [profitInvoices, setProfitInvoices] = useState([]);
  const [viewInvoiceModal, setviewInvoiceModal] = useState(false);
  const [downloadId, setDownloadId] = useState('');
  const [downloadCondensedId, setDownloadCondensedId] = useState('');
  const [downloadingSpinner, setDownloadingSpinner] = useState(false);
  const [downloadingCondensedSpinner, setDownloadingCondensedSpinner] = useState(false);
  const [anchorE2, setAnchorE2] = React.useState("");
  const [anchorE3, setAnchorE3] = React.useState("");
  const [shippingDateValue, setShippingDateValue] = useState([]);
  const [selectedShippingDate, setSelectedShippingDate] = useState([]);
  const [pdfData, setPdfData] = useState('')
  const [sortingColumn, setSortingColumn] = useState('invoiceDate');
  const [sortingOrder, setSortingOrder] = useState('DESC');
  const [propsModelList, setPropsModelList] = useState([])
  const [tradeProductId, setTradeProductId] = useState('');
  const [searchLoading, setSearchLoading] = useState(false)
  const [accessData, setAccessData] = useState([]);
  const [DownloadInvoice, setDownloadInvoice] = useState(false);
  const [loader, setloader] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [invoiceDateRange, setInvoiceDateRange] = useState([]);
  const [selectedInvoiceDate, setSelectedInvoiceDate] = useState([]);
  const [key, setKey] = useState(0);
  const accountId = window.sessionStorage.getItem('accountId');
  const [tradeModelName, setTradeModelName] = useState(null);
  const [tradeModelNumber, setTradeModelNumber] = useState(null);
  const [tradeInventoryPrice, setTradeInventoryPrice] = useState(null);
  const [profitFilters, setProfitFilters] = useState(null);
  const [tradeMiscCategory, setTradeMiscCategory] = useState(null);
  const [watchType, setWatchType] = useState("standard_watch");
  const [modelNameErrorText, setModelNameErrorText] = useState("");
  const [modelNumberErrorText, setModelNumberErrorText] = useState("");
  const [miscCategoryErrorText, setMiscCategoryErrorText] = useState("");
  const [checkPaymentStatus, setCheckPaymentStatus] = useState("");
  const [paymentContactBased, setPaymentContactBased] = useState([]);
  const [openMemoInvoiceHistoryModal, setOpenMemoInvoiceHistoryModal] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [totalInvoicePages, setTotalPages] = useState(1);
  const [totalDetails, setTotalDetails] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [paidAmount, setPaidAmount] = useState(null)
  const [openPayBackModal, setOpenPayBackModal] = useState(false);
  const [payBackAmount, setPayBackAmount] = useState("");
  const [payBackDate, setPayBackDate] = useState(null);
  const [payBackMethod, setPayBackMethod] = useState(null);
  const [payBackDetails, setPayBackDetails] = useState("");
  const [payBackRemainingAmount, setPayBackRemainingAmount] = useState(null);
  const [payBackTotalAmount, setPayBackTotalAmount] = useState(null);
  const [payBackFormInvalid, setPayBackFormInvalid] = useState(false);
  const [payBackErrAmount, setPayBackErrAmount] = useState(null);
  const [payBackMethodErrorText, setPayBackMethodErrorText] = useState("");
  const [payBackSubmitLoading, setPayBackSubmitLoading] = useState(false);
  const history = useHistory();
  const [amountRange, setAmountRange] = useState(["", ""]);
  const [appliedFilterName, setAppliedFilterName] = useState("");
  const isDisabled =
    (paymentStatus === "Partially Paid" && (!amount || !paymentMethod)) ||
    (paymentStatus !== "Partially Paid" && paymentStatus !== "Fully Paid") || errRemainingAmt;
  const isPayBackDisabled = payBackFormInvalid || !payBackAmount || !payBackMethod;
  const [tradeInventory, setTradeInventory] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [invoiceListData, setInvoiceListData] = useState([]);
  const [currentItem, setCurrentItem] = useState(null);
  const [tradeModel, setTradeModel] = useState("");
  const [tradeSerialNumber, setTradeSerialNumber] = useState("");

  const inputRef = useRef(null);
  const shipinputRef = useRef(null);
  const modelinputRef = useRef(null);
  const serialinputRef = useRef(null);
  const [inventoryError, setInventoryError] = useState("");
  const [inventoryid, setInventoryID] = useState(null);
  const [type, setType] = useState(null);
  const [selectedInventoryModel, setSelectedInventoryModel] = useState("");
  const [selectedInventorySerial, setSelectedInventorySerial] = useState("");
  const [selectedInventoryPrice, setSelectedInventoryPrice] = useState("");
  const [selectedInventoryModelName, setSelectedInventoryModelName] = useState("");
  const [selectInventoryModelNumber, setSelectInventoryModelNumber] = useState("");
  const [selectedInventoryCategory, setSelectedInventoryCategory] = useState("");
  const [tradeWatchType, setTradeWatchType] = useState("");
  const [purchaseExpenseModal, setPurchaseExpenseModal] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [voidInventoryModal, setvoidInventoryModal] = useState(false);
  const [purchaseIgnoreReason, setPurchaseIgnoreReason] = useState('');
  const isQboVerified = window.sessionStorage.getItem('isQboVerified') === 'true';
  const [showQboWarning, setShowQboWarning] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [initialAmount, setInitialAmount] = useState("");
  const [selectedInvoicesForVoid, setSelectedInvoicesForVoid] = useState([]);
  const [bulkVoidInvoices, setBulkVoidInvoices] = useState([]);
  const payBackPaymentMethods = ["Affirm", "Cash", "Check", "Crypto", "Paypal", "Venmo", "Wire", "Zelle"]
  const dealerContactPaymentMethods = ["Affirm", "Cash", "Check", "Credit Card", "Crypto", "Paypal", "Scrap Gold", "Trade", "Venmo", "Wire", "Zelle"];
  const [showBulkUpdatePaymentModal, setShowBulkUpdatePaymentModal] = useState(false);
  const [bulkPaymentAmount, setBulkPaymentAmount] = useState("");
  const [bulkPaymentDate, setBulkPaymentDate] = useState(null);
  const [bulkPaymentMethod, setBulkPaymentMethod] = useState("");
  const [bulkPaymentDetails, setBulkPaymentDetails] = useState("");
  const [bulkPaymentAmountError, setBulkPaymentAmountError] = useState("");
  const [bulkPaymentDateError, setBulkPaymentDateError] = useState("");
  const [bulkPaymentMethodError, setBulkPaymentMethodError] = useState("");
  const [bulkPaymentSubmitting, setBulkPaymentSubmitting] = useState(false);

  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     fetchData();
  //   }, 2000);
  //   return () => clearTimeout(delayDebounce);
  // }, [amountRange]);

  useEffect(() => {
    if (invoiceFilter) {
      setpageNo(1);
      fetchData(invoiceFilter);
      return;
    }

    if (amountRange[0] === "" && amountRange[1] === "") {
      setpageNo(1);
      fetchData(null, 1);
      return;
    }
    const delayDebounce = setTimeout(() => {
      if (amountRange[0] !== "" || amountRange[1] !== "") {
        setpageNo(1);
        fetchData(null, 1);
      }
    }, 1000);

    return () => clearTimeout(delayDebounce);
  }, [invoiceFilter, amountRange]);
  useEffect(() => {
    if (!openQBOInvoiceModal && !openQBOConfigModal) {
      document.body.style.overflow = "auto";
    }
  }, [openQBOInvoiceModal, openQBOConfigModal]);

  useEffect(() => {
    setKey(prevKey => prevKey + 1);
  }, [selectedInvoiceDate])

  useEffect(() => {
    const accessData1 = getComponentActionList('invoices')
    setAccessData(accessData1)
  }, [])
  useEffect(() => {
    if (!tradeInventory && inventoryid) {
      if (type) {
        setTradeWatchType(type);
      }

      if (selectedInventoryModel) {
        setTradeModel(selectedInventoryModel);
      }

      if (selectedInventorySerial) {
        setTradeSerialNumber(selectedInventorySerial);
      }
      if (selectedInventoryPrice) {
        setTradeInventoryPrice(selectedInventoryPrice);
      }
      if (selectedInventoryModelName) {
        setTradeModelName(selectedInventoryModelName);
      }
      if (selectInventoryModelNumber) {
        setTradeModelNumber(selectInventoryModelNumber)
      }
      if (selectedInventoryCategory) {
        setTradeMiscCategory(selectedInventoryCategory)
      }
    }
  }, [
    tradeInventory,
    inventoryid,
    type,
    selectedInventoryModel,
    selectedInventorySerial,
    selectedInventoryPrice,
    selectedInventoryModelName,
    selectInventoryModelNumber,
    selectedInventoryCategory
  ]);
  // useEffect(() => {
  //   if (watchType === "misc_watch") {
  //     const serialNumber = "Not Available-" + new Date().getTime();
  //     setSerialNo(serialNumber);
  //   } else {
  //     setSerialNo("");
  //   }
  // }, [watchType]);

  useEffect(() => {
    const isTradePayment = paymentMethod?.toLowerCase() === "trade" || bulkPaymentMethod?.toLowerCase() === "trade";

    if (
      isTradePayment &&
      tradeInventory &&
      watchType === "misc_watch" &&
      (!serialNo || !String(serialNo).startsWith("Not Available-"))) {
      setSerialNo(`Not Available-${Date.now()}`);
    }
  }, [paymentMethod, bulkPaymentMethod, watchType, tradeInventory]);

  // const handleSort = (columnId) => {
  //   let order = 'asc';
  //   if (sortingColumn === columnId && sortingOrder === 'asc') {
  //     order = 'desc';
  //   }
  //   setSortingColumn(columnId);
  //   setSortingOrder(order);

  //   const sortedRows = [...rows].sort((a, b) => {
  //     let valueA = a[columnId];
  //     let valueB = b[columnId];

  //     if (typeof valueA === 'string' && typeof valueB === 'string') {
  //       return valueA.localeCompare(valueB);
  //     } else if (typeof valueA === 'number' && typeof valueB === 'number') {
  //       return valueA - valueB;
  //     } else if (valueA instanceof Date && valueB instanceof Date) {
  //       return valueA.getTime() - valueB.getTime();
  //     } else if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
  //       return valueA === valueB ? 0 : valueA ? -1 : 1;
  //     } else {
  //       return String(valueA).localeCompare(String(valueB));
  //     }
  //   });

  //   if (order === 'desc') {
  //     sortedRows.reverse();
  //   }
  //   setRows(sortedRows);
  // };

  const valueAmountRangeFormat = (value) => {
    if (value === "0") return "0";
    if (value > 120000) return "UNKNOWN";
    return `${value}`;
  };
  const inventoryAmountRangeInterval = (value) => {
    setAmountRange(value);
    setAppliedFilterName("");
  };
  const handleAmountRangeChange = (event, newValue) => {
    setAmountRange(newValue);
    setpageNo(1);
  };
  const handleMinInputChange = (event) => {
    const raw = event.target.value;
    const min = raw === "" ? "" : Math.max(0, Number(raw));
    setAmountRange([min, amountRange[1]]);
    if (raw === "" && amountRange[1] === "") {
      fetchData(null, 1, false);
      setpageNo(1);
    }
  };

  const handleMaxInputChange = (event) => {
    const raw = event.target.value;
    const max = raw === "" ? "" : Math.max(0, Number(raw));
    setAmountRange([amountRange[0], max]);
    if (raw === "" && amountRange[0] === "") {
      fetchData();
      setpageNo(1);
    }
  };

  const handleSort = (columnId) => {
    let order = 'asc';
    if (sortingColumn === columnId && sortingOrder === 'asc') {
      order = 'desc';
    }
    setSortingColumn(columnId);
    setSortingOrder(order);
    setRows([]);
    setSelectedInvoicesForVoid([]);
    setBulkVoidInvoices([]);
    setpageNo(1);
    setloader(true);
    const apiSortField = sortFieldMap[columnId] || columnId;
    fetchData(null, 1, apiSortField, order.toUpperCase());
  };

  const openButton = Boolean(anchorE3);
  const handleClickButton = (event) => {
    setAnchorE3(event.currentTarget)
  }
  const handleCloseButton = () => {
    setAnchorE3('');
  };
  const openAction = Boolean(anchorE2);
  const handleClick = (event, row) => {
    setAnchorE2(event.currentTarget);
    setSelectedInvoice(row);
  };

  const canBulkVoid = isActionAllowed(accessData, "void_invoice");
  // Admin (2), Owner (3), Expert (6) can void/edit payments
  const canManagePaymentsByRole = [2, 3, 6].includes(
    Number(userDetails?.roleId)
  );
  const canVoidPayment =
    canManagePaymentsByRole ||
    isActionAllowed(accessData, "void_payment");
  const canEditPayment =
    canManagePaymentsByRole ||
    isActionAllowed(accessData, "edit_payment");
  const showBulkVoidCheckboxes = canBulkVoid && invoiceTypeFilter !== "memo" && paymentStatusFilter !== "Void";
  // console.log(userDetails?.roleId,"userDetails?.roleId",userDetails)
  const canViewInvoiceProfit =
    userDetails?.roleId === 2 || userDetails?.roleId === 6 || userDetails?.roleId === 3;

  const invoiceTableColumns = useMemo(() => {
    if (!canViewInvoiceProfit) return columns;
    const profitColumn = { id: "profit", label: "Profit ($)", minWidth: 130 };
    const statusIndex = columns.findIndex((column) => column.id === "status");
    const nextColumns = [...columns];
    nextColumns.splice(statusIndex + 1, 0, profitColumn);
    return nextColumns;
  }, [canViewInvoiceProfit]);

  const getInvoiceProfitValue = (row) => {
    const profitValue =
      row?.profitdifrerence ?? row?.profitdifference ?? row?.profit;
    if (profitValue === null || profitValue === undefined || profitValue === "") {
      return null;
    }
    const profitNum = Number(profitValue);
    return Number.isNaN(profitNum) ? null : profitNum;
  };

  const formatInvoiceDisplayAmount = (value) => {
    if (value === null || value === undefined || value === "" || value === "-") {
      return "-";
    }
    const num = Number(value);
    if (Number.isNaN(num)) return value;
    return amountFormatter(num);
  };

  const isInvoiceVoidable = (row) => {
    if (!canBulkVoid) return false;
    if (row.invoicetype === "Memo Invoice") return false;
    if (row.status !== "Active") return false;
    if (row.is_shopify_from === true) return false;
    if (
      row.paymentstatus === "Fully Paid" &&
      userDetails?.roleId == "2" &&
      userDetails?.roleId == "3" &&
      userDetails?.roleId == "6"
    ) {
      return false;
    }
    return true;
  };

  // Shopify invoices are selectable for Profit / Update Payment; Void still uses isInvoiceVoidable
  const isInvoiceSelectable = (row) => {
    if (!showBulkVoidCheckboxes) return false;
    if (row.invoicetype === "Memo Invoice") return false;
    if (row.status !== "Active") return false;
    return true;
  };

  const handleToggleInvoiceSelection = (row) => {
    if (!isInvoiceSelectable(row)) return;
    setSelectedInvoicesForVoid((prev) => {
      const exists = prev.some((item) => item.id === row.id);
      if (exists) {
        return prev.filter((item) => item.id !== row.id);
      }
      return [...prev, row];
    });
  };

  const selectableRowsOnPage = rows.filter(isInvoiceSelectable);
  const voidableSelectedInvoices = selectedInvoicesForVoid.filter(isInvoiceVoidable);
  const canBulkVoidSelected = voidableSelectedInvoices.length > 0;

  const allSelectableSelected =
    selectableRowsOnPage.length > 0 &&
    selectableRowsOnPage.every((row) =>
      selectedInvoicesForVoid.some((item) => item.id === row.id)
    );
  const someSelectableSelected = selectableRowsOnPage.some((row) =>
    selectedInvoicesForVoid.some((item) => item.id === row.id)
  );

  const handleSelectAllSelectable = (checked) => {
    if (checked) {
      setSelectedInvoicesForVoid((prev) => {
        const merged = [...prev];
        selectableRowsOnPage.forEach((row) => {
          if (!merged.some((item) => item.id === row.id)) {
            merged.push(row);
          }
        });
        return merged;
      });
    } else {
      const selectableIds = new Set(selectableRowsOnPage.map((row) => row.id));
      setSelectedInvoicesForVoid((prev) =>
        prev.filter((item) => !selectableIds.has(item.id))
      );
    }
  };

  const handleBulkVoidClick = () => {
    if (!canBulkVoidSelected) return;

    const needsQboWarning = voidableSelectedInvoices.some(
      (row) =>
        isQboVerified &&
        row.paymentstatus === "Fully Paid" &&
        row.is_invoice_qbo_synced !== true &&
        row.qbo_isverified !== true
    );

    if (needsQboWarning) {
      setPendingAction("BULK_VOID");
      setShowQboWarning(true);
    } else {
      setBulkVoidInvoices(voidableSelectedInvoices);
      setCancelModal(true);
    }
  };

  const handleProfitCalculate = () => {
    if (selectedInvoicesForVoid.length === 0) return;
    setProfitInvoices(selectedInvoicesForVoid);
    setProfitFilters({
      userId: userDetails?.userId,
      accountId: accountId,
      paymentStatus: paymentStatusFilter,
      inventoryType: inventoryTypeFilter === "ALL" ? null : inventoryTypeFilter,
      billingSearch: searchKeyword ? searchKeyword?.replace(/[\p{P}]/gu, "") : "",
      type: invoiceTypeFilter,
      memoInvoiceStatus: memoInvoiceStatusFilter,
      pageNo: pageNo,
      limit: limit,
      filters: {},
      sortField: "invoiceDate",
      sortOrder: "DESC",
    });
    setOpenProfitModal(true);
  };

  const isInvoicePayable = (row) =>
    row?.paymentstatus === "Partially Paid" || row?.paymentstatus === "Not Paid";

  const showBulkUpdatePaymentButton =
    selectedInvoicesForVoid.length > 0 &&
    selectedInvoicesForVoid.every(isInvoicePayable);

  const bulkPaymentMethodOptions = useMemo(() => {
    if (!selectedInvoicesForVoid.length) return [];
    const lists = selectedInvoicesForVoid.map((inv) =>
      inv?.is_include_dealercontact
        ? dealerContactPaymentMethods
        : (inv?.acceptable_payment?.length ? inv.acceptable_payment : dealerContactPaymentMethods)
    );
    return [...new Set(lists.flat())].sort((a, b) => a.localeCompare(b));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInvoicesForVoid]);

  const resetBulkTradeFields = () => {
    handleNonTrade();
    clearTradeFields();
    handleClearInventory();
    setCurrentItem(null);
    setWatchType("standard_watch");
    setTradeProductId(null);
    setModel("");
    setSerialNo(null);
    setModelErrorText("");
    setSerialNoErrorText("");
    setModelNameErrorText("");
    setMiscCategoryErrorText("");
    setModelNumberErrorText("");
    setInventoryError("");
    setSearchText("");
    setPropsModelList([]);
    setSearchObj((prevState) => ({
      ...prevState,
      searchVal: "",
      searchText: "",
      from: "trade",
    }));
  };

  const handleOpenBulkUpdatePayment = () => {
    if (!showBulkUpdatePaymentButton) return;
    setBulkPaymentAmount("");
    setBulkPaymentDate(null);
    setBulkPaymentMethod("");
    setBulkPaymentDetails("");
    setBulkPaymentAmountError("");
    setBulkPaymentDateError("");
    setBulkPaymentMethodError("");
    resetBulkTradeFields();
    setShowBulkUpdatePaymentModal(true);
  };

  const handleCloseBulkUpdatePayment = () => {
    if (bulkPaymentSubmitting) return;
    setShowBulkUpdatePaymentModal(false);
    resetBulkTradeFields();
  };

  const onBulkPaymentMethodChange = (event) => {
    const { value } = event.target;
    setBulkPaymentMethod(value);
    if (value) setBulkPaymentMethodError("");
    if (value === "Trade") {
      setTradeInventory(true);
      setBulkPaymentAmountError("");
    } else {
      resetBulkTradeFields();
    }
  };

  const validateBulkTradeFields = () => {
    let hasError = false;
    if (!tradeInventory && (!currentItem || !currentItem.inventoryid)) {
      setInventoryError("Please select atleast one existing inventory to proceed!");
      hasError = true;
    } else {
      setInventoryError("");
    }

    if (tradeInventory) {
      if (watchType === "standard_watch" && (!modelNo || !tradeProductId)) {
        setModelErrorText("Please select Model");
        hasError = true;
      } else if (watchType === "standard_watch") {
        setModelErrorText("");
      }

      if ((watchType === "standard_watch" || watchType === "misc_watch") && !serialNo) {
        setSerialNoErrorText("Please enter Serial Number");
        hasError = true;
      } else {
        setSerialNoErrorText("");
      }

      if (watchType === "misc_product" && !tradeMiscCategory) {
        setMiscCategoryErrorText("Please select Misc Category");
        hasError = true;
      } else if (watchType === "misc_product") {
        setMiscCategoryErrorText("");
      }

      if (watchType === "misc_product" && !tradeModelName) {
        setModelNameErrorText("Please enter Model Name");
        hasError = true;
      } else if (watchType === "misc_product") {
        setModelNameErrorText("");
      }
    }
    return hasError;
  };

  const buildBulkTradePayload = () => {
    const tradeInvoiceType = !tradeInventory && inventoryid ? type || watchType : watchType;
    const isExistingInventorySelected = tradeInventory === false && !!inventoryid;
    return {
      // Backend maps trade inventory to this one invoice (or first of invoiceIds)
      invoiceId: selectedInvoicesForVoid[0]?.id,
      invoiceType: tradeInvoiceType,
      model: modelNo,
      serialNo: serialNo,
      productId: (currentItem && currentItem.productid) || tradeProductId || null,
      modelNo: tradeModelNumber,
      modelName: tradeModelName,
      serialNumber: tradeSerialNumber,
      miscCategory: tradeMiscCategory,
      isOldTrade: !tradeInventory,
      oldTradeInventoryId: !tradeInventory && inventoryid ? inventoryid : null,
      ...(isExistingInventorySelected
        ? {
          old_purchase_price: tradeInventoryPrice,
          purchase_price: parseFloat(bulkPaymentAmount),
          purchaseprice: parseFloat(bulkPaymentAmount),
          eventrequestchanged: {
            is_purchesd_price_edit: true,
            from: tradeInventoryPrice,
            to: parseFloat(bulkPaymentAmount),
          },
        }
        : {}),
    };
  };

  const submitBulkUpdatePayment = (event) => {
    event.preventDefault();
    const isTrade = bulkPaymentMethod === "Trade";
    let hasError = false;

    if (!bulkPaymentAmount || parseFloat(bulkPaymentAmount) <= 0) {
      setBulkPaymentAmountError("Please enter a valid amount");
      hasError = true;
    } else {
      // Compare against the same total shown in the modal, in cents, so that
      // paying exactly the displayed balance never trips float rounding.
      const amtCents = Math.round(parseFloat(bulkPaymentAmount) * 100);
      const balanceCents = Math.round(bulkTotalBalance * 100);
      if (amtCents > balanceCents && !isTrade) {
        setBulkPaymentAmountError(
          "Payment amount exceeds the total open balance of the selected invoices. Overpayment is not allowed for this payment type."
        );
        hasError = true;
      } else {
        setBulkPaymentAmountError("");
      }
    }
    if (!bulkPaymentDate) {
      setBulkPaymentDateError("Please select a payment date");
      hasError = true;
    } else {
      setBulkPaymentDateError("");
    }
    if (!bulkPaymentMethod) {
      setBulkPaymentMethodError("Please select Payment Method");
      hasError = true;
    } else {
      setBulkPaymentMethodError("");
    }
    if (isTrade && validateBulkTradeFields()) {
      hasError = true;
    }
    if (hasError) return;

    const tradedInventoryId =
      isTrade && !tradeInventory && inventoryid ? inventoryid : null;

    setBulkPaymentSubmitting(true);
    const data = {
      invoiceIds: selectedInvoicesForVoid.map((inv) => inv.id),
      amount: parseFloat(bulkPaymentAmount),
      paymentDate: bulkPaymentDate,
      paymentMethod: bulkPaymentMethod,
      paymentmethod_details: bulkPaymentDetails || "",
      userid: userDetails?.userId,
      accountId: accountId,
      ...(isTrade ? buildBulkTradePayload() : {}),
    };

    updatePaymentStatusMultiple(data, (error, res) => {
      setBulkPaymentSubmitting(false);
      if (error || res?.status !== 1) {
        showErrorToast(res?.message || error || "Failed to update payment");
        return;
      }
      const updates = Array.isArray(res?.data) ? res.data : [];
      setRows((prevRows) =>
        prevRows.map((row) => {
          const match = updates.find((item) => item.invoiceId === row.id);
          return match
            ? { ...row, paymentstatus: match.paymentStatus, balance: match.remainingBalance }
            : row;
        })
      );
      if (tradedInventoryId) {
        setInvoiceListData((prev) =>
          prev.filter(
            (item) =>
              Number(item.inventoryid || item.inventoryId) !== Number(tradedInventoryId)
          )
        );
      }
      setSelectedInvoicesForVoid([]);
      setShowBulkUpdatePaymentModal(false);
      resetBulkTradeFields();
      showSuccessToast(res?.message || "Payment updated successfully");
    });
  };

  const handleCloseAction = async (identifier) => {
    setAnchorE2("");
    setSelectedInvoice(null);
    setOpenInvoiceTransactionModal(false);
    setOpenMemoInvoiceHistoryModal(false);
    setOpenShippingInfoModal(false);
    setCancelModal(false);
    setBulkVoidInvoices([]);
    setOpenProfitModal(false);
    setProfitInvoices([]);
    setviewInvoiceModal(false)
    setPdfData('');

    if (identifier === 'fetch') {
      setloader(true);
      const dashboardData = {
        userId: userDetails?.userId,
        accountId: accountId,
        paymentStatus: paymentStatusFilter,
        inventoryType: inventoryTypeFilter === "ALL" ? null : inventoryTypeFilter,
        type: invoiceTypeFilter,
        memoInvoiceStatus: memoInvoiceStatusFilter,
        billingSearch: searchKeyword ? searchKeyword?.replace(/[\p{P}]/gu, "") : "",
      };
      if (selectedShippingDate && selectedShippingDate.length > 0) {
        dashboardData['shippingDateInterval'] = {
          from: selectedShippingDate[0].format(),
          to: selectedShippingDate[1].format()
        }
      }
      if (selectedInvoiceDate && selectedInvoiceDate.length > 0) {
        dashboardData['invoiceDateDetails'] = {
          from: selectedInvoiceDate[0].format(),
          to: selectedInvoiceDate[1].format()
        }
      }
      setDisabled(true);
      // props.fetchInvoiceList(dashboardData);
      await props.fetchInvoiceList(dashboardData, (error, response) => {
        setDisabled(false);
        setloader(false);
      });

    }
  };

  useEffect(() => {
    setSelectedInvoicesForVoid([]);
    setBulkVoidInvoices([]);
  }, [
    paymentStatusFilter,
    inventoryTypeFilter,
    invoiceTypeFilter,
    memoInvoiceStatusFilter,
    selectedShippingDate,
    selectedInvoiceDate,
    amountRange,
  ]);

  useEffect(() => {
    fetchData();
  }, [
    paymentStatusFilter,
    inventoryTypeFilter,
    invoiceTypeFilter,
    memoInvoiceStatusFilter,
    selectedShippingDate,
    selectedInvoiceDate,
  ]);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    if (shipinputRef.current) {
      shipinputRef.current.focus();
    }
    if (modelinputRef.current) {
      modelinputRef.current.focus();
    }
    if (serialinputRef.current) {
      serialinputRef.current.focus();
    }
    getInvoiceList();
  }, []);
  const getInvoiceList = () => {
    getUserdetailsforsubscrption.getAllInvoiceList(
      accountId,
      (error, response) => {
        if (response && response.status == 1) {
          const raw = response.data || [];
          const cleaned = raw.filter((o) => {
            if (!o || typeof o !== "object") return false;
            const hasUseful =
              (o.model && String(o.model).trim()) ||
              (o.serialno && String(o.serialno).trim()) ||
              (o.inventoryid && String(o.inventoryid).trim()) ||
              (o.productid && String(o.productid).trim()) ||
              (o.productId && String(o.productId).trim());
            return !!hasUseful;
          });

          const normalized = cleaned.map((item) => {
            const inventoryid = item.inventoryid || item.inventoryId || item.id || null;
            const model =
              item.model && String(item.model).trim()
                ? item.model
                : item.inventory_title || item.modelname || item?.technical_details?.product_title || item?.technical_details?.product_name || "";
            const serialno = item.serialno || item.serial || "";
            const productid = item.productid || item.productId || item.product_id || null;
            // const type = inventoryid ? "automatic" : item.type || null;
            const type = item.type || null;

            return {
              ...item,
              inventoryid: inventoryid,
              productid: productid,
              model: model,
              serialno: serialno,
              type: type,
            };
          });

          const filteredFinal = normalized.filter((it) => {
            const invType = it.inventorytype ?? it.inventory_type ?? null;
            return !(invType === "4" || invType === 4);
          });
          setInvoiceListData(filteredFinal);
        }
      }
    );
  };

  const fetchData = async (invoiceFilter = null, pageNos = pageNo, sortFieldParam = "invoiceDate", sortOrderParam = "DESC") => {
    // if (pageNo > 1) {
    //   } else {
    //   setloader(true);
    // }
    const dashboardData = {
      userId: userDetails?.userId,
      accountId: accountId,
      paymentStatus: paymentStatusFilter,
      inventoryType: inventoryTypeFilter === "ALL" ? null : inventoryTypeFilter,
      billingSearch: searchKeyword ? searchKeyword.replace(/[\p{P}]/gu, "").trim() : "",
      type: invoiceTypeFilter,
      memoInvoiceStatus: memoInvoiceStatusFilter,
      pageNo: pageNos,
      limit: limit,
      filters: {},
      sortField: sortFieldParam,
      sortOrder: sortOrderParam,
      // invoiceDateInterval: invoiceDateInterval === 'ALL' ? 0 : invoiceDateInterval,
    };

    if (selectedShippingDate && selectedShippingDate.length > 0) {
      dashboardData['shippingDateInterval'] = {
        from: selectedShippingDate[0].format(),
        to: selectedShippingDate[1].format()
      };
    }
    if (selectedInvoiceDate && selectedInvoiceDate.length > 0) {
      dashboardData['invoiceDateDetails'] = {
        from: selectedInvoiceDate[0].format(),
        to: selectedInvoiceDate[1].format()
      }
    }
    const minVal = amountRange[0] === "" ? 0 : Number(amountRange[0]);
    // allow any numeric max; blank => null
    const maxVal = amountRange[1] === "" ? null : Number(amountRange[1]);
    dashboardData["amountRange"] = { min: minVal, max: maxVal };
    if (minVal === 0 && maxVal === null) {
      delete dashboardData.amountRange;
    }
    setloader(true);
    setDisabled(true);
    await props.fetchInvoiceList(invoiceFilter ? invoiceFilter : dashboardData, (error, response) => {
      setloader(false);
      setDisabled(false)
      if (response && response.data) {
        if (response?.pageNo > 1) {
          setRows((prev) => [...prev, ...response.data]);
        } else {
          setRows(response.data);
          setTotalDetails({ totalActiveCount: response.totalActiveCount, totalVoidCount: response.totalVoidCount, totalInvoiceSum: response.totalInvoiceSum, totalVoidSum: response.totalVoidSum });

        }
        //   // setHasMore(response.invoiceList.length === limit);
        // if (response.data.length > 0 && response?.data?.totalPages > 1) {
        setTotalPages(response?.totalPages);
        if (response.data.length) {
          setHasMore(true);
        } else {
          setHasMore(false);
        }
      }
    });
  };

  useEffect(() => {
    if (shippingDateValue && shippingDateValue.length === 2) {
      setSelectedShippingDate(shippingDateValue);
    }
    if (shippingDateValue?.length === 0 && selectedShippingDate && selectedShippingDate.length === 2) {
      setSelectedShippingDate([]);
    }
    if (invoiceDateRange && invoiceDateRange.length === 2) {
      setSelectedInvoiceDate(invoiceDateRange);
      setpageNo(1);
    }
    if (invoiceDateRange?.length === 0 && selectedInvoiceDate && selectedInvoiceDate.length === 2) {
      setSelectedInvoiceDate([]);
      setpageNo(1);
    }
  }, [shippingDateValue, invoiceDateRange])

  // useEffect(() => {
  //   setRows(props?.invoiceDetails?.invoiceDashboardList?.list);
  // }, [JSON.stringify(props?.invoiceDetails?.invoiceDashboardList)]);

  // useEffect(() => {
  //   if (loader) {
  //     setloader(false)
  //   }
  // }, [rows])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (Object.keys(searchObj).length && searchObj?.searchVal?.length > 2) {
        setSearchLoading(true)
        searchProductsAPI(searchObj, (error, res) => {
          setSearchLoading(false)
          if (error) {
            // console.log(error, res)
          }
          if (res && res.data) {
            setPropsModelList(res.data)
          }
        })
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchObj]);

  useEffect(() => {
    if (propsModelList && propsModelList.length) {
      setAnchorEl(anchorTarget);
    } else {
      if (searchObj?.searchVal) {
        setNoData(true);
      }
    }

    if (searchObj?.column === "modelNumber") {
      // setInventoryId(props.inventoryid)
      setModelList(propsModelList);
    }
  }, [propsModelList]);

  useEffect(() => {
    setModelErrorText("");
    setSerialNoErrorText("");
    setMiscCategoryErrorText("");
    setModelNameErrorText("");
    setModelNumberErrorText("");
    setTradeModelName("");
    if (watchType !== "misc_watch") {
      setModel("");
      setSerialNo("");
    }
  }, [watchType]);
  useEffect(() => {
    if (paymentMethod?.toLowerCase() === "trade") {
      setRemaingAmtError(null);
      setFormInvalid(false);
      setTradeModelName("");
      setTradeModelNumber("")
      setTradeInventoryPrice("");
      setWatchType("standard_watch")
      if (watchType !== "misc_watch") {
        setModel("");
        setSerialNo("");
      }
    }
  }, [paymentMethod]);

  useEffect(() => {
    if (!amount) return;
    const isTrade = paymentMethod?.toLowerCase() === "trade";
    const remainingAmt =
      parseFloat(remainingBalance) > 0
        ? parseFloat(remainingBalance)
        : parseFloat(totalAmt);

    if (!isTrade && parseFloat(amount) > remainingAmt) {
      setRemaingAmtError("Amount should not exceed remaining amount");
      setFormInvalid(true);
      setRemainingAmount(remainingAmt.toFixed(2));
    } else {
      setRemaingAmtError(null);
      setFormInvalid(false);
      setRemainingAmount((remainingAmt - parseFloat(amount)).toFixed(2));
    }
  }, [paymentMethod, amount, remainingBalance, totalAmt]);
  const fetchMoreData = () => {
    const nextPage = pageNo + 1;
    setpageNo(nextPage);
    const apiSortField = sortFieldMap[sortingColumn] || sortingColumn;
    fetchData(null, nextPage, apiSortField, sortingOrder);
  };

  const onPaymentStatusChange = (event) => {
    let paymentStatusVal = event.target.value;
    if (paymentStatusVal) {
      setPaymentStatus(paymentStatusVal);
      if (paymentStatusVal === "Fully Paid") {
        const remainingAmt = remainingBalance > 0 ? remainingBalance : totalAmt;
        setAmount(remainingAmt);
        setRemainingAmount(0);
        setDisableAmount(true);
        setRemaingAmtError("");
        setPaidAmount(totalAmt);
      } else {
        setAmount("");
        setRemainingAmount(remainingBalance);
        setDisableAmount(false);
        setPaidAmount("0.00")
      }
    }
  };

  const handleNavigateInvoice = () => {
    const invoiceFilter = {
      userId: userDetails?.userId,
      accountId: accountId,
      paymentStatus: paymentStatusFilter,
      inventoryType: inventoryTypeFilter === "ALL" ? null : inventoryTypeFilter,
      billingSearch: searchKeyword ? searchKeyword?.replace(/[\p{P}]/gu, "") : "",
      type: invoiceTypeFilter,
      memoInvoiceStatus: memoInvoiceStatusFilter,
    };
    if (invoiceType === "memo_invoice") {
      props.history.push({
        pathname: "/create/memoinvoice",
        state: { invoiceFilter, deposit }
      });
    }
    else {
      props.history.push({
        pathname: "/create/invoice",
        state: { invoiceFilter, isConvertToSale: false, deposit }
      });
    }
  }

  const onAmountChange = (event) => {
    const isTrade = paymentMethod?.toLowerCase() === "trade";
    const value = event.target.value;
    const validAmountRegex = isTrade
      ? /^-?\d+(\.\d*)?$/
      : /^\d+(\.\d*)?$/;

    let amountVal =
      event.target.value.match(validAmountRegex) !== null
        ? event.target.value
        : parseFloat(event.target.value).toFixed(2);
    if (Number(amountVal)) {
      const remainingAmt =
        parseFloat(remainingBalance) > 0
          ? parseFloat(remainingBalance)
          : parseFloat(totalAmt);
      if (!isTrade && parseFloat(amountVal) > remainingAmt) {
        setRemaingAmtError("Amount should not exceed remaining amount");
        setFormInvalid(true);
        setAmount(amountVal);
        setRemainingAmount(remainingAmt.toFixed(2));
      } else {
        setAmount(amountVal);
        setFormInvalid(false);
        setRemaingAmtError(null);
        const newRemainingAmount = remainingAmt - parseFloat(amountVal);
        setRemainingAmount(newRemainingAmount.toFixed(2));
        if (parseFloat(remainingBalance) > 0) {
          setRemainingAmount(
            (parseFloat(remainingBalance) - parseFloat(amountVal))
          );
        } else {
          setRemainingAmount(parseFloat(totalAmt) - parseFloat(amountVal)).toFixed(2);
        }
        if (!paymentMethod) {
          setPaymentMethodErrorText("Please select Payment Method");
        } else {
          setPaymentMethodErrorText(null);
        }
        if (paymentContactBased.length === 0) {
          setPaymentMethodErrorText("No Preferred Payment Method has been set for the contact");
        }
      }
    } else {
      setAmount("");
      setRemainingAmount(remainingBalance);
      // setPaidAmount();
      setPaymentMethodErrorText(null);
      setRemaingAmtError(null);
    }
  };

  const handleSearch = (e, column) => {
    const { value } = e.target
    setNoData(false);
    setAnchorTarget(e.currentTarget);
    // setCurrentSearch(column);
    setModelErrorText("");
    setPaymentMethodErrorText("");
    setModel(value);
    setTradeProductId(null)
    const string = value ? value.replace(/[&\/\\#,+!@^&()$~%.'":;*?<>{}]/g, '') : '';
    setSearchObj({ column, searchVal: value, searchText: string, from: 'trade' });
  };

  const onPaymentMethodChange = (event) => {
    const { value } = event.target;
    setPaymentMethod(value);
    if (value) {
      setPaymentMethodErrorText(null);
    }
    if (parseFloat(amount) < 0 && value !== "Trade") {
      setRemaingAmtError("This Payment Method does not accept negative values.");
    }
    if (parseFloat(amount) < 0 && value === "Trade") {
      setRemaingAmtError(null);
    }
    if (value == 'Trade') {
      setTradeInventory(true);
    }
    if (value !== "Trade") {
      handleNonTrade();
      clearTradeFields();
    }
  };

  const handleNonTrade = () => {
    setModel(null);
    setSerialNo(null);
    setTradeModelName(null);
    setTradeModelNumber(null);
    setTradeMiscCategory(null);
    setTradeInventory(false);
    setInventoryID(null);
    setCurrentItem(null);

    setSelectedInventoryModel("");
    setSelectedInventorySerial("");
    setSelectedInventoryPrice("");

    setSelectedInventoryModelName("");
    setSelectInventoryModelNumber("");
    setSelectedInventoryCategory("");

    setInventoryError("");
  }
  const clearTradeFields = () => {
    setTradeSerialNumber(null);
    setTradeInventoryPrice(null);
    setValue("tradeSerialNumber", "");
  };

  const onRemainingAmountChange = (event) => {
    let remainingAmountVal = parseFloat(event.target.value).toFixed(2);
    if (remainingAmountVal) {
      setRemainingAmount(remainingAmountVal);
    }
  };

  const onSerialNoChange = (event) => {
    let serialNoVal = event.target.value;
    setSerialNoErrorText("");
    if (serialNoVal) {
      setSerialNo(serialNoVal);
    } else {
      setSerialNo(null);
    }
  };
  const onPaymentDetails = (event) => {
    setPaymentDetails(event.target.value);
  }

  const onPaymentStatusFilter = (event) => {
    let paymentMethodVal = event.target.value;
    if (paymentMethodVal) {
      setPaymentStatusFilter(paymentMethodVal);
      setpageNo(1);
    }
  };

  const oninventoryTypeFilter = (event) => {
    let inventoryTypeVal = event.target.value;
    if (inventoryTypeVal) {
      setinventoryTypeFilter(inventoryTypeVal);
      setpageNo(1);
    }
  };

  const handleSendToQBO = (row) => {
    handleCloseAction();
    setInvoiceId(row.id);
    setAccountId(row.accountId);
    setOpenQBOConfigModal(true);
  };
  const openDealerPushModal = (row) => {
    handleCloseAction();
    setCreatedInvoiceId(row.id);
    setCreatedInvoiceType(row.invoicetype);
    setDealerPushConfirmOpen(true);
  };

  const handleDealerPushDecision = (isYes) => {
    const isDataPush = isYes ? false : true;
    setDealerPushConfirmOpen(false);
    setSubmitLoading(true);

    const payload = {
      invoiceId: createdInvoiceId,
      is_dataPush: isDataPush,
      ...(createdInvoiceType === "Memo Invoice" ? { type: "Memo" } : {}),
    };

    props.invoiceDataPush(
      payload,
      (error, response) => {
        setSubmitLoading(false);
        if (error) {
          if (isYes) {
            showErrorToast("Failed to push inventory to the dealer account.");
          }
          setCreatedInvoiceId(null);
          setCreatedInvoiceType(null);
          return;
        }
        if (response?.status === 1) {
          showSuccessToast("Inventory pushed to the buyer's dealer account successfully");
        }
        fetchData();
        setCreatedInvoiceId(null);
        setCreatedInvoiceType(null);
      });
  };

  const handleNoClick = () => {
    setDealerPushConfirmOpen(false);
    setCreatedInvoiceType(null);
  };

  const bulkTotalBalance = useMemo(() => {
    const parseAmt = (val) => {
      if (val === null || val === undefined || val === "") return 0;
      const num = parseFloat(String(val).replace(/[^0-9.\-]/g, ""));
      return isNaN(num) ? 0 : num;
    };
    return selectedInvoicesForVoid.reduce((sum, inv) => {
      const balance =
        inv?.paymentstatus === "Not Paid" ? inv?.totalprice : inv?.balance;
      return sum + parseAmt(balance);
    }, 0);
  }, [selectedInvoicesForVoid]);

  const handleCloseQBO = () => {
    setOpenQBOConfigModal(false);
    document.body.style.overflow = "auto";
    // setQboInvoiceId(null);
  };
  const handleCloseQBOInvoice = () => {
    setOpenQBOInvoiceModal(false);
    document.body.style.overflow = "auto";
    // setQboInvoiceId(null);
  };
  // const openVoidAfterExpense = (purchaseIgnoreReason) => {
  //       setPurchaseExpenseModal(false);   
  //       setvoidInventoryModal(true);
  //       setPurchaseIgnoreReason(purchaseIgnoreReason);   
  // };
  const oninvoiceTypeFilter = (event) => {
    let { value } = event.target;
    if (value) {
      setinvoiceTypeFilter(value);
      setpageNo(1);
    }
  };

  const onmemoInvoiceStatusFilter = (event) => {
    let { value } = event.target;
    if (value) {
      setmemoInvoiceStatusFilter(value);
      setpageNo(1);
    }
  };

  const fetchInvoicesGrid = async (from = null, pageNos = pageNo, append = false, sortFieldParam = sortingColumn, sortOrderParam = sortingOrder) => {
    if (!append) {
      setSelectedInvoicesForVoid([]);
      setBulkVoidInvoices([]);
    }
    const dashboardData = {
      userId: userDetails?.userId,
      accountId: accountId,
      paymentStatus: paymentStatusFilter,
      inventoryType: inventoryTypeFilter === "ALL" ? null : inventoryTypeFilter,
      type: invoiceTypeFilter,
      memoInvoiceStatus: memoInvoiceStatusFilter,
      billingSearch: from === "clear" ? "" : searchKeyword?.replace(/[\p{P}]/gu, "").trim(),
      pageNo: pageNos,
      limit: limit,
      filters: {},
      sortField: sortFieldParam,
      sortOrder: sortOrderParam,

      // invoiceDateInterval: invoiceDateInterval === 'ALL' ? 0 : invoiceDateInterval,
    };
    if (selectedShippingDate && selectedShippingDate.length > 0) {
      dashboardData['shippingDateInterval'] = {
        from: selectedShippingDate[0].format(),
        to: selectedShippingDate[1].format()
      }
    }
    if (selectedInvoiceDate && selectedInvoiceDate.length > 0) {
      dashboardData['invoiceDateDetails'] = {
        from: selectedInvoiceDate[0].format(),
        to: selectedInvoiceDate[1].format()
      }
    }
    const minVal = amountRange[0] === "" ? 0 : Number(amountRange[0]);
    // allow any numeric max; blank => null
    const maxVal = amountRange[1] === "" ? null : Number(amountRange[1]);
    dashboardData["amountRange"] = { min: minVal, max: maxVal };
    if (minVal === 0 && maxVal === null) {
      delete dashboardData.amountRange;
    }
    setpageNo(1);
    setloader(true);
    setDisabled(true);
    // props.fetchInvoiceList(dashboardData);
    await props.fetchInvoiceList(dashboardData, (error, response) => {
      setloader(false);
      setDisabled(false);
      if (response && response.data) {
        if (response?.pageNo > 1) {
          setRows((prev) => [...prev, ...response.data]);
        } else {
          setRows(response.data);
          setTotalDetails({ totalActiveCount: response.totalActiveCount, totalVoidCount: response.totalVoidCount, totalInvoiceSum: response.totalInvoiceSum, totalVoidSum: response.totalVoidSum });

        }
        //   // setHasMore(response.invoiceList.length === limit);
        // if (response.data.length > 0 && response?.data?.totalPages > 1) {
        setTotalPages(response?.data?.totalPages);
        if (response.data.length) {
          setHasMore(true);
        } else {
          setHasMore(false);
        }
      }
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelection = (val, columnId) => {
    setModel(val.model);
    setCurrentItem(val);
    setInventoryID(val.inventoryid);
    setAnchorEl(null);
    setValue("modelNumber", val.model);
    setTradeProductId(val.productid)
    setModelErrorText("");
    setPaymentMethodErrorText("");
    setPropsModelList([]);
    setSearchObj((prevState) => ({ ...prevState, searchVal: "", searchText: "", from: 'trade' }));
    setSelectedInventoryModel(val?.model || "");
    setSelectedInventorySerial(val?.serialno || "");
    setSelectedInventoryPrice(val.purchaseprice || "")
    setTradeInventoryPrice(val.purchaseprice || "")

    setSelectedInventoryModelName(val?.technical_details?.product_name || "");
    setSelectInventoryModelNumber(val?.technical_details?.model_number || "");
    setSelectedInventoryCategory(val?.category || "");
    const finalType = val?.type
      ? (val.type === "misc_watch" || val.type === "misc_product")
        ? val.type
        : "standard_watch"
      : "standard_watch";
    setWatchType(finalType);
  };

  const submitPaymentForm = (event) => {
    setSubmitLoading(true)
    event.preventDefault();
    setModelErrorText("");
    setPaymentMethodErrorText("");
    setSerialNoErrorText("");
    setModelNameErrorText("");
    setMiscCategoryErrorText("");
    setModelNumberErrorText("");
    setRemaingAmtError("");
    const isTrade = paymentMethod?.toLowerCase() === "trade";
    const isExistingInventorySelected = tradeInventory === false && inventoryid;
    const tradedInventoryId = isExistingInventorySelected ? inventoryid : null;
    const hasAmount = !!amount;
    const shouldSendEventRequestChanged =
      isTrade &&
      isExistingInventorySelected &&
      hasAmount;
    let data = {
      paymentStatus: paymentStatus,
      amount: amount,
      old_amount: initialAmount,
      paymentDate: paymentDate,
      paymentMethod: paymentMethod,
      remainingBalance: remainingAmount,
      invoiceId: invoiceId,
      model: modelNo,
      serialNo: serialNo,
      paymentmethod_details: paymentdetails,
      description: description,
      userid: userDetails?.userId,
      accountId: accountId,
      productId: tradeProductId,
      invoiceType: resolvedType || watchType,
      modelNo: tradeModelNumber,
      modelName: tradeModelName,
      serialNumber: tradeSerialNumber,
      miscCategory: tradeMiscCategory,
      ...(paymentMethod === "Trade"
        ? {
          isOldTrade: !tradeInventory ? true : false,
          oldTradeInventoryId: !tradeInventory && inventoryid ? inventoryid : null,
          ...(shouldSendEventRequestChanged
            ? {
              old_purchase_price: tradeInventoryPrice,
              purchase_price: amount,
              purchaseprice: amount,
            }
            : {}),
        }
        : {}),
    };
    if (shouldSendEventRequestChanged) {
      data.eventrequestchanged = {
        is_purchesd_price_edit: true,
        from: tradeInventoryPrice,
        to: amount,
      };
    }
    const dashboardData = {
      userId: userDetails?.userId,
      accountId: accountId,
      paymentStatus: paymentStatusFilter,
      inventoryType: inventoryTypeFilter === "ALL" ? null : inventoryTypeFilter,
      type: invoiceTypeFilter,
      memoInvoiceStatus: memoInvoiceStatusFilter,
      billingSearch: searchKeyword ? searchKeyword?.replace(/[\p{P}]/gu, "") : "",
    };
    if (selectedShippingDate && selectedShippingDate.length > 0) {
      dashboardData['shippingDateInterval'] = {
        from: selectedShippingDate[0].format(),
        to: selectedShippingDate[1].format()
      }
    }
    if (selectedInvoiceDate && selectedInvoiceDate.length > 0) {
      dashboardData['invoiceDateDetails'] = {
        from: selectedInvoiceDate[0].format(),
        to: selectedInvoiceDate[1].format()
      }
    }
    let isValid = false;
    if (paymentStatus?.toLowerCase() === "partially paid" && !amount) {
      setRemaingAmtError("Please enter Amount");
      // console.log('11111111111111111111')
      isValid = true;
    }
    if (paymentStatus?.toLowerCase() !== "not paid" && !paymentMethod) {
      setPaymentMethodErrorText("Please select Payment Method");
      // console.log('22222222222222222')

      isValid = true;
    }
    if (paymentContactBased.length === 0) {
      setPaymentMethodErrorText("No Preferred Payment Method has been set for the contact");
      // console.log('3333333333333')

      isValid = true;
    }
    if (parseFloat(amount) < 0 && paymentMethod?.toLowerCase() !== "trade") {
      setRemaingAmtError("This Payment Method does not accept negative values.");
      // console.log('44444444444444444444444')

      isValid = true;
    }
    if (
      paymentMethod === "Trade" &&
      !tradeInventory &&
      (!currentItem || !currentItem.inventoryid)
    ) {
      setInventoryError("Please select atleast one existing inventory to proceed!");
      // console.log('5555555555555555555555555555')

      isValid = true;
    } else {
      setInventoryError("");
    }
    const isTradePayment = paymentMethod?.toLowerCase() === "trade";
    const remainingAmtForValidation =
      parseFloat(remainingBalance) > 0
        ? parseFloat(remainingBalance)
        : parseFloat(totalAmt);
    if (!isTradePayment && amount && parseFloat(amount) > remainingAmtForValidation) {
      setRemaingAmtError("Amount should not exceed remaining amount");
      // console.log('555555555555555555555')

      isValid = true;
    }
    if (paymentMethod?.toLowerCase() === "trade" && tradeInventory) {
      if (watchType === "standard_watch" && !modelNo) {
        setModelErrorText("Please select Model");
        // console.log('666666666666666666666666')

        isValid = true;
      }
      if ((watchType === "standard_watch" || watchType === "misc_watch") && !serialNo && tradeInventory) {
        setSerialNoErrorText("Please enter Serial Number");
        // console.log('77777777777777777777')

        isValid = true;
      }
      if (watchType === "standard_watch" && !tradeProductId && tradeInventory) {
        setModelErrorText("Please select Model");
        // console.log('8888888888888888888888')

        isValid = true;
      }
      if (watchType === "misc_product" && !tradeMiscCategory) {
        setMiscCategoryErrorText("Please select Misc Category");
        // console.log('99999999999999999')

        isValid = true;
      }
      if (watchType === "misc_product" && !tradeModelName) {
        setModelNameErrorText("Please enter Model Name");
        // console.log('10101010101')

        isValid = true;
      }
      // if (watchType === "misc_product" && !tradeModelNumber) {
      //   setModelNumberErrorText("Please enter Model Number");
      //   isValid = true;
      // }
    }
    if (isValid) {
      setSubmitLoading(false)
      return;
    }
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === invoiceId
          ? { ...row, paymentstatus: paymentStatus, balance: remainingAmount }
          : row
      )
    );
    setloader(true);
    // if (currentItem.productid) {
    //   data.productId = currentItem.productid;
    // }
    if (currentItem && currentItem.productid) {
      data.productId = currentItem.productid;
    } else if (tradeProductId) {
      data.productId = tradeProductId;
    } else {
      data.productId = null;
    }
    updatePaymentStatus(data, (error, res) => {
      if (res?.status == 1 || res?.success || res?.code == 200) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === invoiceId
              ? { ...row, paymentstatus: paymentStatus, balance: remainingAmount }
              : row
          )
        );
        setAmount("")
        setRemainingBalance(remainingAmount)
        setPaymentDetails("")
        setPaymentdDate(null)
        setPaymentMethod("")
        handleNonTrade();
        clearTradeFields();
        handleClearInventory();
        setCurrentItem(null);
        const qboSynced =
          res?.is_invoice_qbo_synced === true ||
          res?.data?.is_invoice_qbo_synced === true ||
          res?.invoice?.is_invoice_qbo_synced === true;
        const invoiceObj =
          res?.invoice ||
          res?.data ||
          selectedInvoice;
        if (qboSynced) {
          setSelectedInventory(invoiceObj);
          setOpenQBOInvoiceModal(true);
        }
        if (tradedInventoryId) {
          setInvoiceListData((prev) =>
            prev.filter(
              (data) =>
                Number(data.inventoryid || data.inventoryId) !==
                Number(tradedInventoryId)
            )
          );
          getInvoiceList();
        }
        const paidAmt = parseFloat(totalAmt) - remainingAmount;
        setPaidAmount(paidAmt.toFixed(2));
        if (serialNo && serialNo.includes("-")) {
          const parts = serialNo.split("-");
          if (parts.length > 1) {
            const lastPart = parts[parts.length - 1];
            if (!isNaN(lastPart)) {
              const newNumber = (parseInt(lastPart) + 1).toString();
              const newSerialNo = parts.slice(0, -1).join("-") + "-" + newNumber;
              setSerialNo(newSerialNo);
            } else {
              setSerialNo(serialNo + "-1");
            }
          } else {
            setSerialNo(serialNo + "-1");
          }
        }

        if (res?.qbostatus == 3) {
          toast(res?.message || "QuickBooks warning", {
            position: toast.POSITION.TOP_RIGHT,
            type: toast.TYPE.WARNING,
          });
        } else {
          toast("Payment status updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            type: toast.TYPE.SUCCESS,
          });
        }
        // showSuccessToast("Payment status updated successfully");
        // setRows([]);
        if (!qboSynced) {
          setpageNo(1);
          fetchInvoicesGrid(null, 1, false);
        }
        // props.fetchInvoiceList(dashboardData, (error, response) => {
        //   setloader(false);
        // });
        setloader(false)
        const isPartiallyPaid = paymentStatus?.toLowerCase() === "partially paid";
        const amount = parseFloat(remainingAmount) || 0;

        if (
          !isPartiallyPaid ||
          amount === 0 ||
          (isPartiallyPaid && paymentMethod?.toLowerCase() === "trade" && amount <= 0)
        ) {
          setModalOpen(false);
        }
      }
      else {
        setloader(false);
        showErrorToast(res?.message || res?.data?.message || "Something went wrong");
      }
      if (error) {
        setloader(false);
        showErrorToast(error);
      }
      setSubmitLoading(false)
    });
  };

  const handleAddItem = () => {
    const row = selectedInvoice;
    setAmount(null);
    setInitialAmount(row.amount);
    setDescription(null);
    setDisableAmount(false);
    setRemaingAmtError(null);
    handleCloseAction();
    setPaymentStatus(row?.paymentstatus);
    // setPaymentMethod(row?.paymentmethod);
    setPaymentDetails(row?.paymentmethod_details);
    // if (row.paymentmethod && row.paymentmethod.toLowerCase() === "trade") {
    //   setModel(row?.reference);
    //   setSerialNo(row?.serialno);
    // } else {
    //   setModel(null);
    //   setSerialNo(null);
    // }
    setModel(null);
    setSerialNo(null);
    // setPaymentContactBased(row?.acceptable_payment && row?.acceptable_payment.length > 0 ? row?.acceptable_payment : [])
    setPaymentContactBased(
      row?.is_include_dealercontact
        ? dealerContactPaymentMethods
        : (row?.acceptable_payment && row?.acceptable_payment.length > 0 ? row?.acceptable_payment : [])
    )
    setTradeProductId(null);
    const total = parseFloat(row?.totalprice || 0);
    const balance = parseFloat(row?.balance ?? row?.totalprice ?? 0);
    const paid = total - balance;
    setRemainingAmount(balance.toFixed(2));
    setRemainingBalance(balance.toFixed(2));
    setTotalAmt(total.toFixed(2));
    setPaidAmount(paid.toFixed(2));
    setPaymentdDate(null);
    setInvoiceId(row?.id);
    setInvoiceDate(row?.invoicedate);
    setModalOpen(!openModal);
    setWatchType("standard_watch");
    handleNonTrade();
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModelErrorText("");
    setPaymentMethod(null);
    setPaymentMethodErrorText("");
    setSerialNoErrorText("");
    setAnchorEl(null);
    setPropsModelList([]);
    setModel("");
    setSearchLoading(false);
    setSearchObj((prevState) => ({ ...prevState, searchVal: "", searchText: "", from: 'trade' }));
    setOpenInvoiceModal(false);
    setInvoiceType("regular_invoice")
    handleNonTrade();
    setTradeInventory(false);
    setInventoryID(null);
    setType(null);
    setTradeModel(null);
    setTradeModelName(null);
    setTradeModelNumber(null);
    setTradeInventoryPrice(null);
    setTradeMiscCategory(null);
    setTradeSerialNumber(null);
    setTradeInventoryPrice(null)
    setWatchType("standard_watch");
  };

  const handlePayBack = () => {
    const row = selectedInvoice;
    handleCloseAction();
    setPayBackAmount("");
    setPayBackDate(null);
    setPayBackMethod(null);
    setPayBackDetails("");
    setPayBackErrAmount(null);
    setPayBackMethodErrorText("");
    setPayBackFormInvalid(false);

    const balance = parseFloat(row?.balance || 0);
    setPayBackRemainingAmount(balance.toFixed(2));
    setPayBackTotalAmount(parseFloat(row?.totalprice || 0).toFixed(2));
    setInvoiceId(row?.id);
    setInvoiceDate(row?.invoicedate);
    // setPaymentContactBased(payBackPaymentMethods);
    setPaymentContactBased(dealerContactPaymentMethods);
    setOpenPayBackModal(true);
  };

  const handleClosePayBackModal = () => {
    setOpenPayBackModal(false);
    setPayBackAmount("");
    setPayBackDate(null);
    setPayBackMethod(null);
    setPayBackDetails("");
    setPayBackErrAmount(null);
    setPayBackMethodErrorText("");
    setPayBackFormInvalid(false);
  };
  const uiType =
    !tradeInventory && inventoryid
      ? type === null
        ? "standard_watch"
        : type
      : watchType;

  const resolvedType = !tradeInventory && inventoryid ? type : watchType;
  const onPayBackAmountChange = (event) => {
    const value = event.target.value;
    const cleanValue = value.replace(/[^0-9.]/g, "");
    setPayBackAmount(cleanValue);

    const amountVal = parseFloat(cleanValue);
    const currentBalance = parseFloat(payBackRemainingAmount) || 0;

    if (!isNaN(amountVal)) {
      const newRemaining = currentBalance + amountVal;

      if (amountVal <= 0) {
        setPayBackErrAmount("Amount must be greater than 0");
        setPayBackFormInvalid(true);
      } else if (amountVal > Math.abs(currentBalance)) {
        setPayBackErrAmount("Payback amount cannot exceed the outstanding credit");
        setPayBackFormInvalid(true);
      } else {
        setPayBackErrAmount(null);
        setPayBackFormInvalid(false);
      }
    } else {
      setPayBackErrAmount(null);
      setPayBackFormInvalid(false);
    }
  };

  const onPayBackMethodChange = (event) => {
    const { value } = event.target;
    setPayBackMethod(value);
    if (value) {
      setPayBackMethodErrorText(null);
    }
  };

  const submitPayBackForm = (event) => {
    setPayBackSubmitLoading(true);
    event.preventDefault();
    setPayBackErrAmount(null);
    setPayBackMethodErrorText(null);

    let isValid = false;

    const currentBalance = parseFloat(payBackRemainingAmount) || 0;
    const parsedPayBackAmount = parseFloat(payBackAmount);

    if (!parsedPayBackAmount || parsedPayBackAmount <= 0) {
      setPayBackErrAmount("Please enter Amount");
      isValid = true;
    }

    if (!payBackMethod) {
      setPayBackMethodErrorText("Please select Payment Method");
      isValid = true;
    }

    if (paymentContactBased.length === 0) {
      setPayBackMethodErrorText("No Preferred Payment Method has been set for the contact");
      isValid = true;
    }

    if (Math.abs(parsedPayBackAmount) > Math.abs(currentBalance)) {
      setPayBackErrAmount("Amount should not exceed remaining amount");
      isValid = true;
    }

    if (isValid) {
      setPayBackSubmitLoading(false);
      return;
    }

    const newRemainingBalance = currentBalance + parsedPayBackAmount;

    const data = {
      paymentStatus: paymentStatusFilter,
      amount: parsedPayBackAmount,
      paymentDate: payBackDate,
      paymentMethod: payBackMethod,
      remainingBalance: newRemainingBalance.toFixed(2),
      invoiceId: invoiceId,
      paymentmethod_details: payBackDetails,
      userid: userDetails?.userId,
      accountId: accountId,
      payBack: true,
    };

    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === invoiceId
          ? {
            ...row,
            balance: newRemainingBalance.toFixed(2),
            paymentstatus: newRemainingBalance === 0 ? "Fully Paid" : "Partially Paid",
          }
          : row
      )
    );
    setloader(true)
    updatePaymentStatus(data, (error, res) => {
      if (res?.status === 1) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === invoiceId
              ? {
                ...row, balance: newRemainingBalance.toFixed(2),
                paymentstatus: newRemainingBalance === 0 ? "Fully Paid" : "Partially Paid"
              }
              : row
          )
        );
        setPayBackAmount("")
        setPayBackRemainingAmount(newRemainingBalance.toFixed(2))
        setPayBackDetails("")
        setPayBackDate(null)
        setPayBackMethod("")
        if (res?.qbostatus == 3) {
          toast(res?.message || "QuickBooks warning", {
            position: toast.POSITION.TOP_RIGHT,
            type: toast.TYPE.WARNING,
          });
        } else {
          toast("Payment status updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
            type: toast.TYPE.SUCCESS,
          });
        }
        const qboSynced =
          res?.is_invoice_qbo_synced === true ||
          res?.data?.is_invoice_qbo_synced === true ||
          res?.invoice?.is_invoice_qbo_synced === true;

        const invoiceObj = res?.invoice || res?.data || selectedInvoice;
        const returnedInvoiceId = res?.invoiceid || res?.data?.invoiceid || invoiceObj?.id || invoiceId || null;
        const returnedAccountId = res?.accountid || res?.data?.accountid || invoiceObj?.accountId || accountIds || null;

        if (qboSynced) {
          setSelectedInventory(invoiceObj);
          if (returnedInvoiceId) setInvoiceId(returnedInvoiceId);
          if (returnedAccountId) setAccountId(returnedAccountId);
          setOpenQBOInvoiceModal(true);
        } else {
          history.push("/invoices");
        }
        if (!qboSynced) {
          setpageNo(1);
          fetchInvoicesGrid(null, 1, false);
        }
        if (newRemainingBalance === 0) {
          setOpenPayBackModal(false);
        }
      }
      if (error) {
        showErrorToast(error);
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === invoiceId
              ? { ...row, balance: currentBalance.toFixed(2) }
              : row
          )
        );
      }
      setPayBackSubmitLoading(false);
    });
  };

  const handleChangePage = (evesetSelectedInvoicent, newPage) => {
    setpageNo(newPage);
  };

  const handleTransactionModal = (from, paymentStatus) => {
    const row = selectedInvoice;
    handleCloseAction();
    if (row.id) {
      setSelectedInvoice(row);
    }
    if (from === "SHIPPING-INFO") {
      setOpenShippingInfoModal(!openShippingInfoModal);
      setCheckPaymentStatus(paymentStatus === "Fully Paid" ? paymentStatus : "");
    } else {
      setOpenInvoiceTransactionModal(!openInvoiceTransactionModal);
      setCheckPaymentStatus("");
    }
  };

  const handleMemoInvoiceHistoryModal = (row) => {
    if (row?.id) {
      handleCloseAction();
      setSelectedInvoice(row);
      setOpenMemoInvoiceHistoryModal(true);
    }
  };

  const handleClearButton = () => {
    setSearchKeyword("");
    setloader(true);
    setRows([]);
    setpageNo(1);
    fetchInvoicesGrid("clear", 1, false);
  };

  const handleEnterEvent = (event) => {
    if (event.key == "Enter") {
      fetchInvoicesGrid(null, 1, false);
      setRows([]);
      setpageNo(1);
      setloader(true);
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setLimit(+event.target.value);
    setpageNo(1);
  };
  const handleClearInventory = () => {
    setCurrentItem(null);
    setInventoryID(null);

    setSelectedInventoryModel("");
    setSelectedInventorySerial("");
    setSelectedInventoryPrice("")

    setSelectedInventoryModelName("");
    setSelectInventoryModelNumber("");
    setSelectedInventoryCategory("");

    setInventoryError("");
  };

  const onChangeOfCheckBoxInventory = (event) => {
    const checked = event.target.checked;
    setTradeInventory(checked);
    setTradeModel("");
    setTradeSerialNumber("");
    setTradeInventoryPrice("");
    setTradeModelName("");
    setTradeModelNumber("");
    setTradeMiscCategory("");
    setWatchType("standard_watch");
    setModel("");
    setSerialNo("");
    setSearchText("");
    setValue("modelAndSerial", null);
    if (!checked) {
      setInventoryID(null);
      setSelectedInventoryModel("");
      setSelectedInventorySerial("");
      setSelectedInventoryPrice("")

      setSelectedInventoryModelName("");
      setSelectInventoryModelNumber("");
      setSelectedInventoryCategory("");
      setType(null);
      setTradeModel(null);
      setTradeModelName(null);
      setTradeModelNumber(null);
      setTradeInventoryPrice(null);
      setTradeMiscCategory(null);
      setTradeSerialNumber(null);
      setTradeInventoryPrice(null);
    }
  };


  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const RectValueLabel = styled(SliderValueLabel)(({ theme }) => ({
    backgroundColor: '#e53935',
    color: '#fff',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 600,
    padding: '2px 4px',
    transform: 'none !important',
    top: '10px',
    '&:before': { display: 'none' },
  }));
  const handleMouseDown = (event) => {
    event.preventDefault();
  };
  const endAdornment = () => {
    const values = searchKeyword;
    if (values) {
      return (
        <InputAdornment position="end">
          <IconButton
            onClick={handleClearButton}
            onMouseDown={handleMouseDown}
            color="primary"
          >
            <ClearIcon />
          </IconButton>
          <IconButton
            className="primary-bg color-white"
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
            onClick={fetchInvoicesGrid}
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      );
    } else {
      return (
        <InputAdornment position="end">
          <IconButton
            className="primary-bg color-white"
            type="button"
            sx={{ p: "10px" }}
            aria-label="search"
            onClick={fetchInvoicesGrid}
          >
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      );
    }

    return "";
  };

  function CustomInput({ onFocus, value, onChange, label = "Date" }) {

    return (
      <TextField
        id="outlined-basic"
        label={label}
        variant="outlined"
        onFocus={onFocus}
        style={{ width: "100%" }}
        placeholder="from YYYY/MM/DD to YYYY/MM/DD"
        onPaste={(event) => event.preventDefault()}
        value={value}
        onChange={onChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <CalendarMonthIcon />
            </InputAdornment>
          ),
          style: { height: "45px" },
          readOnly: true,
        }}
        disabled={disabled}
        inputProps={{ autoComplete: "off" }}
      />
    )
  }

  const downloadInvoiceTotal = (type) => {
    setDownloadInvoice(true)
    const dashboardData = {
      userId: userDetails?.userId,
      accountId: accountId,
      paymentStatus: paymentStatusFilter,
      inventoryType: inventoryTypeFilter === "ALL" ? null : inventoryTypeFilter,
      type: invoiceTypeFilter,
      memoInvoiceStatus: memoInvoiceStatusFilter,
      billingSearch: searchKeyword ? searchKeyword?.replace(/[\p{P}]/gu, "") : "",
    };
    if (selectedShippingDate && selectedShippingDate.length > 0) {
      dashboardData['shippingDateInterval'] = {
        from: selectedShippingDate[0].format(),
        to: selectedShippingDate[1].format()
      }
    }
    if (selectedInvoiceDate && selectedInvoiceDate.length > 0) {
      dashboardData['invoiceDateDetails'] = {
        from: selectedInvoiceDate[0].format(),
        to: selectedInvoiceDate[1].format()
      }
    }
    const minVal = amountRange[0] === "" ? 0 : Number(amountRange[0]);
    // allow any numeric max; blank => null
    const maxVal = amountRange[1] === "" ? null : Number(amountRange[1]);
    dashboardData["amountRange"] = { min: minVal, max: maxVal };
    if (minVal === 0 && maxVal === null) {
      delete dashboardData.amountRange;
    }
    // dashboardData['invoiceDateInterval'] = invoiceDateInterval === 'ALL' ? 0 : invoiceDateInterval
    alldownloadInvoice(
      dashboardData, selectedInvoice?.id
    ).then((res) => {
      setDownloadInvoice(false)
      if (res && res.status === 0) {
        toast(res.message || 'Something went wrong', {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    });
  }

  const calculateTotalValueofInvoices = useMemo(() => {
    const total = rows?.reduce((total, item) => {
      if (item?.status === 'Active' || item?.status === 'Open') {
        return total + (Number(item?.totalprice) || 0);
      }
      return total;
    }, 0);

    return total.toLocaleString('en-US');
  }, [rows])

  const renderPaymentStatus = (status, reason) => {
    const styles = {
      fontWeight: "600",
      color:
        status === "Fully Paid"
          ? "#3CB878"
          : status === "Partially Paid"
            ? "orange"
            : status === "Over Paid"
              ? "#006400"
              : status === "Not Paid"
                ? "#034DA2"
                : "#F76568",
    };

    if (status === "Void" && reason) {
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
          <span style={styles}>{status}</span>
          <BootstrapTooltip title={`Void Reason: ${reason}`}>
            <span style={{ display: "inline-flex", alignItems: "center" }}>
              <InfoOutlinedIcon
                style={{ fontSize: 14, color: "rgba(0, 0, 0, 0.54)", cursor: "pointer" }}
              />
            </span>
          </BootstrapTooltip>
        </span>
      );
    }
    return <p style={styles}>{status}</p>;
  };

  const renderColumnContent = (column, row) => {
    const value = row[column.id];
    const memoNumber = row["memonumber"];
    const invoiceType = row["invoicetype"];

    switch (column.id) {
      case "totalprice":
        return formatInvoiceDisplayAmount(value);
      case "remainingbalance":
        if (invoiceType === "Memo Invoice") return "NA";
        if (row.paymentstatus === "Not Paid") {
          return formatInvoiceDisplayAmount(row.totalprice);
        }
        return formatInvoiceDisplayAmount(row.balance);
      case "createdby":
        return row.createdbyname || "-";
      case "invoicenumber":
        return value || memoNumber || "-";
      case "contactname":
        return (
          row?.contactname?.trim() ||
          (row?.firstname && row?.lastname
            ? `${row.firstname} ${row.lastname}`
            : row?.firstname || row?.lastname) || "-");
      case "invoicesrcurl":
        return (
          <Link href={`${value}`} target="_blank">
            Download PDF
          </Link>
        );
      case "invoicedate":
        return value ? formatDate(value, "MM/DD/YYYY") : "-";
      case "solddate":
        return value ? formatDate(value, "MM/DD/YYYY") : "-";
      case "memo_returndate":
        return invoiceType === "Memo Invoice" ?
          value ? formatDate(value, "MM/DD/YYYY") : "-"
          : "NA";
      case "paymentdate":
        return invoiceType === "Memo Invoice" ? "NA"
          : value ? formatDate(value, "MM/DD/YYYY") : "-";
      case "paymentstatus":
        return invoiceType === "Memo Invoice" ? "NA"
          : row["status"] && row["status"] !== "Active"
            ? renderPaymentStatus(row["status"], row["reason"] || row["voidreason"])
            : renderPaymentStatus(value);
      case "profit": {
        if (!canViewInvoiceProfit) return "-";
        if (invoiceType === "Memo Invoice") return "NA";
        if (row["status"] === "Void") return "NA";
        const profitValue = getInvoiceProfitValue(row);
        if (profitValue === null) return "-";
        const profitPercentage = row?.profitpercentage;
        const hasProfitPercentage =
          profitPercentage !== null &&
          profitPercentage !== undefined &&
          profitPercentage !== "" &&
          !Number.isNaN(Number(profitPercentage));

        const formattedProfit = amountFormatter(profitValue);
        if (hasProfitPercentage) {
          return (
            <span style={{ whiteSpace: "nowrap" }}>
              {formattedProfit}
              <span style={{ marginLeft: "4px" }}>
                ({Number(profitPercentage)}%)
              </span>
            </span>
          );
        }
        return formattedProfit;
      }
      default:
        return column.format && typeof value === "number"
          ? column.format(value)
          : value || "-";
    }
  };

  const renderActionsMenu = (row, accessData) => {
    const isDisabled = (status, paymentStatus) => {
      return paymentStatus === "Fully Paid" ||
        paymentStatus === "Over Paid" ||
        status !== "Active";
    };
    const invoiceType = row["invoicetype"];

    const invoiceFilter = {
      userId: userDetails?.userId,
      accountId: accountId,
      paymentStatus: paymentStatusFilter,
      inventoryType: inventoryTypeFilter === "ALL" ? null : inventoryTypeFilter,
      billingSearch: searchKeyword ? searchKeyword?.replace(/[\p{P}]/gu, "") : "",
      type: invoiceTypeFilter,
      memoInvoiceStatus: memoInvoiceStatusFilter,
    };

    // Add shippingDateInterval if selectedShippingDate exists
    if (selectedShippingDate && selectedShippingDate.length > 0) {
      invoiceFilter.shippingDateInterval = {
        from: selectedShippingDate[0].format(),
        to: selectedShippingDate[1].format(),
      };
    }

    // Add invoiceDateDetails if selectedInvoiceDate exists
    if (selectedInvoiceDate && selectedInvoiceDate.length > 0) {
      invoiceFilter.invoiceDateDetails = {
        from: selectedInvoiceDate[0].format(),
        to: selectedInvoiceDate[1].format(),
      };
    }

    return (
      <StyledEngineProvider>
        <Button
          id="demo-customized-button"
          aria-controls={openAction ? "demo-customized-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openAction ? "true" : undefined}
          variant="text"
          disableElevation
          onClick={(e) => handleClick(e, row)}
          style={{
            color: "#1976d2",
            textDecoration: "none",
            textTransform: "none",
            minWidth: "95px",
          }}
          disabled={accessData.length === 0}
          endIcon={<KeyboardArrowDownIcon />}
        >
          <p>Actions</p>
        </Button>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{ "aria-labelledby": "demo-customized-button" }}
          anchorEl={anchorE2}
          open={openAction && (selectedInvoice?.id == row?.id)}
          onClose={() => handleCloseAction()}
        >
          {invoiceType === "Memo Invoice" ?
            <>
              <MenuItem
                onClick={() => handleConvertoSale(row, invoiceFilter)}
                disableRipple
                disabled={row?.status == "Closed" || userDetails?.roleId == "7"}
              >
                <EditIcon />
                Convert to Sale
              </MenuItem>
              <MenuItem
                onClick={() => props.history.push({
                  pathname: "/update/memoinvoice",
                  state: { row, invoiceFilter }
                })}
                disableRipple
                disabled={row?.status == "Closed" || userDetails?.roleId == "7"}
              >
                <EditIcon />
                Update Memo
              </MenuItem>
            </> :
            <>
              {parseFloat(row?.balance) < 0 &&
                (userDetails?.roleId == "2" || userDetails?.roleId == "3" || userDetails?.roleId == "6") && (
                  <MenuItem
                    onClick={handlePayBack}
                    disabled={row.status !== "Active"}
                    disableRipple
                  >
                    <EditIcon />
                    Payback
                  </MenuItem>
                )}
              {isActionAllowed(accessData, "update_payment_status") && (
                <MenuItem
                  onClick={handleAddItem}
                  disabled={isDisabled(row.status, row.paymentstatus) || parseFloat(row?.balance) < 0}
                  disableRipple
                >
                  <EditIcon />
                  Update Payment Status
                </MenuItem>
              )}
              {isActionAllowed(accessData, "update_invoice_details") && (
                <>
                  <MenuItem
                    onClick={() => {
                      if (
                        isQboVerified &&
                        row.paymentstatus === "Fully Paid" &&
                        row.is_invoice_qbo_synced === true &&
                        row.qbo_isverified === true
                      ) {
                        setSelectedInvoice(row);
                        setPendingAction('UPDATE');
                        setShowQboWarning(true);
                      } else {
                        handleTransactionModal("SHIPPING-INFO", row.paymentstatus);
                      }
                    }}
                    // disabled={row.status !== "Active"}
                    // disabled={isDisabled(row.status, row.paymentstatus)}
                    disableRipple
                  >
                    <EditIcon />
                    Update Invoice Details
                  </MenuItem>
                </>
              )}
              {(row.paymentstatus === "Partially Paid" || row.paymentstatus === "Not Paid") &&
                row.status !== "Void" && userDetails?.roleId != "7" && userDetails?.roleId != "8" && userDetails?.roleId != "10" && (
                  <MenuItem disableRipple
                    onClick={() => props.history.push({
                      pathname: "/edit/invoice",
                      state: { row, invoiceFilter }
                    })}>
                    <EditIcon />
                    Edit Invoice
                  </MenuItem>
                )}
            </>
          }
          <Divider sx={{ my: 0.5 }} />
          {isActionAllowed(accessData, "view_transaction_history") && invoiceType !== "Memo Invoice" && (
            <MenuItem onClick={() => handleTransactionModal("TRANSACTION-HISTORY")} disableRipple>
              <DescriptionIcon />
              View Transaction History
            </MenuItem>
          )}
          {isActionAllowed(accessData, "view_invoice") && (
            <>
              <MenuItem onClick={() => setviewInvoiceModal(!viewInvoiceModal)}>
                <VisibilityIcon />
                {invoiceType === "Memo Invoice" ? "View Memo" : "View Invoice"}
              </MenuItem>
              <Divider sx={{ my: 0.5 }} />
            </>
          )}
          {invoiceType === "Memo Invoice" && (
            <MenuItem onClick={() => handleMemoInvoiceHistoryModal(row)} disableRipple>
              <VisibilityIcon />
              View Memo History
            </MenuItem>
          )}
          {isActionAllowed(accessData, "download_invoice") && (
            <MenuItem
              onClick={(e) => {
                if (downloadId === row.id) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                let isMemo = row?.invoicetype === "Memo Invoice" ? true : false;
                setDownloadId(row.id);
                setDownloadingSpinner(true);
                if (row?.itemscount > 10) {
                  toast("Warning: Since this order includes multiple items, the downloaded invoice will display only the catalog images for each product.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 13000,
                    type: toast.TYPE.SUCCESS
                  });
                }
                downloadInvoice(row.id, isMemo, row?.memonumber).then((res) => {
                  setDownloadId("");
                  setDownloadingSpinner(false);
                  if (res.status === 0) {
                    toast.error(res.message || "Something went wrong");
                  } else if (res.url) {
                    setPDF(res.url);
                  }
                });
              }}
              style={{
                cursor: downloadId ? 'not-allowed' : 'pointer',
                opacity: downloadId ? 0.5 : 1,
              }}
              disableRipple
            >
              {downloadId === row.id && downloadingSpinner ? (
                <>
                  <CircularProgress color="inherit" style={{ width: 20, height: 20 }} />
                  <p style={{ paddingLeft: 10 }}>Downloading Invoice...</p>
                </>
              ) : (
                <>
                  <DownloadForOfflineIcon />
                  Download Invoice
                </>
              )}
            </MenuItem>
          )}
          {isActionAllowed(accessData, "download_invoice") && (
            <MenuItem
              onClick={(e) => {
                if (downloadCondensedId === row.id) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                let isMemo = row?.invoicetype === "Memo Invoice" ? true : false;
                setDownloadCondensedId(row.id);
                setDownloadingCondensedSpinner(true);
                if (row?.itemscount > 10) {
                  toast("Warning: Since this order includes multiple items, the downloaded invoice will display only the catalog images for each product.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 10000,
                    type: toast.TYPE.SUCCESS
                  });
                }
                const isCondensed = true;
                downloadInvoice(row.id, isMemo, row?.memonumber, isCondensed).then((res) => {
                  setDownloadCondensedId("");
                  setDownloadingCondensedSpinner(false);
                  if (res.status === 0) {
                    toast.error(res.message || "Something went wrong");
                  } else if (res.url) {
                    setPDF(res.url);
                  }
                });
              }}
              style={{
                cursor: downloadCondensedId ? 'not-allowed' : 'pointer',
                opacity: downloadCondensedId ? 0.5 : 1,
              }}
              disableRipple
            >
              {downloadCondensedId === row.id && downloadingCondensedSpinner ? (
                <>
                  <CircularProgress color="inherit" style={{ width: 20, height: 20 }} />
                  <p style={{ paddingLeft: 10 }}>Downloading Condensed Invoice...</p>
                </>
              ) : (
                <>
                  <DownloadForOfflineIcon />
                  Download Condensed Invoice
                </>
              )}
            </MenuItem>
          )}
          {isActionAllowed(accessData, "void_invoice") && invoiceType !== "Memo Invoice" && (
            <BootstrapTooltip
              title={
                row.is_datatransfer_accepted === true && row.is_include_dealercontact === true
                  ? "This invoice cannot be voided because the inventory has already been transferred to the purchasing dealer and the transfer has been accepted."
                  : ""
              }
            >
              <span>
                <MenuItem
                  onClick={() => {
                    if (
                      isQboVerified &&
                      row.paymentstatus === "Fully Paid" &&
                      row.is_invoice_qbo_synced !== true &&
                      row.qbo_isverified !== true
                    ) {
                      setSelectedInvoice(row);
                      setPendingAction('VOID');
                      setShowQboWarning(true);
                    } else {
                      setBulkVoidInvoices([]);
                      setCancelModal(!openCancelModal);
                    }
                  }}
                  disabled={
                    row.status !== "Active" ||
                    row.is_shopify_from === true ||
                    (row.paymentstatus === "Fully Paid" &&
                      userDetails?.roleId == "2" && userDetails?.roleId == "3" && userDetails?.roleId == "6") ||
                    (row.is_datatransfer_accepted === true && row.is_include_dealercontact === true)
                  }
                  disableRipple
                >
                  <BlockIcon />
                  Void Invoice
                </MenuItem>
              </span>
            </BootstrapTooltip>
          )}
          {row.is_invoice_qbo_synced === true && isQboVerified && (
            <MenuItem
              onClick={() => handleSendToQBO(row)}
              disabled={row.status !== "Active" || row.is_shopify_from === true}
              disableRipple
            >
              <SendIcon />
              Send invoice to QBO
            </MenuItem>
          )}
          {row.is_datatransfer_push === true &&
            userDetails?.roleId !== 7 && (
              <MenuItem
                onClick={() => openDealerPushModal(row)}
                disabled={
                  (invoiceType === "Memo Invoice"
                    ? row.status !== "Open"
                    : row.status !== "Active") || row.is_shopify_from === true
                }
                disableRipple
              >
                <Inventory2Icon />
                Push Inventory
              </MenuItem>
            )}
        </StyledMenu>
      </StyledEngineProvider >
    );
  };

  const handleConvertoSale = (data, invoiceFilter, deposit) => {
    props.history.push({
      pathname: "/create/invoice",
      state: { data, isConvertToSale: true, invoiceFilter, deposit }
    });
  }

  const calculateTotalValueofVoidInvoices = useMemo(() => {
    const total = rows?.reduce((total, item) => {
      if (item?.status === 'Void') {
        return total + (Number(item?.totalprice) || 0);
      }
      return total;
    }, 0);

    return total.toLocaleString('en-US');
  }, [rows])

  const calculateTotalCounts = useMemo(() => {
    return rows.reduce(
      (acc, item) => {
        if (item?.status === 'Void') {
          acc.voidCount += 1;
        } else {
          acc.remainingCount += 1;
        }
        return acc;
      },
      { voidCount: 0, remainingCount: 0 }
    );
  }, [rows]);

  const getContentView = () => {
    return (
      <div style={{ margin: '30px 30px 30px 50px' }}>
        <Grid container spacing={2} >
          <Grid item xs={12} md={8}>
            <Typography type="title" color="inherit">
              <h1><b>Invoices</b></h1>
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            {isActionAllowed(accessData, 'create_invoice') && (
              <>
                <Grid container spacing={1} style={{ margin: 20 }}>
                  <Grid item xs={12} md={5} ><Button
                    id="demo-customized-button"
                    aria-controls={openButton ? 'demo-customized-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openButton ? 'true' : undefined}
                    variant="contained"
                    disableElevation
                    onClick={() => {
                      // props.history.push("/create/invoice");
                      setOpenInvoiceModal(true);
                    }}
                    className={
                      "text-capitalize primary-bg color-white"
                    }
                  // style={{ float: "left" }}
                  // endIcon={<KeyboardArrowDownOutlined />}
                  >
                    Create Invoice
                  </Button ></Grid >
                  <Grid item xs={12} md={6}>
                    <Button
                      id="demo-customized-button"
                      aria-controls={openButton ? 'demo-customized-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openButton ? 'true' : undefined}
                      variant="contained"
                      disableElevation
                      endIcon={DownloadInvoice ? <CircularProgress style={{ width: 22, height: 22, color: '#fff' }} /> : null}
                      // onClick={handleClickButton}
                      onClick={(e) => {
                        if (DownloadInvoice) {
                          e.preventDefault();
                          e.stopPropagation();
                          return;
                        }
                        downloadInvoiceTotal('EX');
                      }}
                      className={
                        "text-capitalize primary-bg color-white"
                      }
                      style={{
                        cursor: DownloadInvoice ? 'not-allowed' : 'pointer',
                        opacity: DownloadInvoice ? 0.5 : 1,
                      }}
                    // style={{ float: "left" }}
                    // endIcon={<KeyboardArrowDownOutlined />}
                    >
                      Download Invoice
                    </Button>
                  </Grid>
                </Grid >
                {/* <StyledMenu
                    id="demo-customized-menu"
                     MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                      }}
                      anchorEl={anchorE3}
                    open={openButton}
                    onClose={handleCloseButton}
                      >
                        <MenuItem onClick={() => {
                         props.history.push("/create/invoice");
                         }} 
                         disableRipple
                         >
                            Create Invoice for Standard Watches
                        </MenuItem>
                       <MenuItem  onClick={() => {
                         props.history.push("/create/invoice/misc");
                         }} 
                         disableRipple
                         >
                       Create Invoice for Misc
                       </MenuItem>
                      </StyledMenu> */}
              </>
            )}
          </Grid >
          <Grid item xs={12} md={3}>
            <div>
              {/* <span onClick={this.removeInventoryType} style={{ float: "right" }}><Icon className={this.state.InventoryType? "fa fa-times-circle" : ""} /></span> */}

              <FormControl variant="outlined" className="formControl">
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  className="font-14"
                  style={{ top: "-4px" }}
                >
                  Inventory Type
                </InputLabel>
                <Select
                  style={{ color: "black", height: "45px" }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  label="Inventory Type"
                  defaultValue={inventoryTypeFilter}
                  //  value={this.state.paymentStatusFilter}
                  onChange={oninventoryTypeFilter}
                  disabled={disabled}
                >
                  <MenuItem value="ALL">All</MenuItem>
                  <MenuItem value="1">Regular Inventory</MenuItem>
                  <MenuItem value="2">Memo Inventory</MenuItem>
                  <MenuItem value="3">Partnership Inventory</MenuItem>
                  <MenuItem value="4">Trade Inventory</MenuItem>
                  <MenuItem value="5">Consignment Inventory</MenuItem>
                  <MenuItem value="NULL">
                    <i>Not Assigned </i>
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
          <Grid item xs={12} md={3}>
            <div>
              <FormControl variant="outlined" className="formControl">
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  className="font-14"
                  style={{ top: "-4px" }}
                >
                  Invoice Type
                </InputLabel>
                <Select
                  style={{ color: "black", height: "45px" }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  label="Invoice Type"
                  defaultValue={invoiceTypeFilter}
                  onChange={oninvoiceTypeFilter}
                  disabled={disabled}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="invoice">Regular Invoice</MenuItem>
                  <MenuItem value="memo">Memo Invoice</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
          <Grid item xs={12} md={3}>
            <div>
              {/* <span onClick={this.removeInventoryType} style={{ float: "right" }}><Icon className={this.state.InventoryType? "fa fa-times-circle" : ""} /></span> */}

              <FormControl variant="outlined" className="formControl">
                <InputLabel
                  id="demo-simple-select-outlined-label"
                  className="font-14"
                  style={{ top: "-4px" }}
                >
                  Payment Status
                </InputLabel>
                <Select
                  style={{ color: "black", height: "45px" }}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  label="Payment Status"
                  defaultValue={paymentStatusFilter}
                  //  value={this.state.paymentStatusFilter}
                  onChange={onPaymentStatusFilter}
                  disabled={disabled}
                >
                  <MenuItem value="ALL">All</MenuItem>
                  <MenuItem value="Fully Paid">Fully Paid</MenuItem>
                  <MenuItem value="Over Paid">Over Paid</MenuItem>
                  <MenuItem value="OpenInvoices">Open Invoices</MenuItem>
                  <MenuItem value="Not Paid">Not Paid</MenuItem>
                  <MenuItem value="Partially Paid">Partially Paid</MenuItem>
                  <MenuItem value="Void">Void</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
          <Grid item xs={12} md={3}>
            <DatePicker
              key={key}
              range
              render={<CustomInput label="Invoice Period" />}
              value={invoiceDateRange}
              containerStyle={{ display: "block" }}
              onChange={dateObjects => {
                setInvoiceDateRange(dateObjects);
                setpageNo(1);
              }}
              rangeHover
              dateSeparator=" to "
              plugins={[
                <DatePanel position="right" />,
                <CustomFooter setInvoiceDateRange={setInvoiceDateRange} />,
              ]}
            />
            {/* <DatePicker
              value={invoiceDateRange}
              onChange={handleDateRangeChange}
              ref={datePickerRef}
              range
              numberOfMonths={2}
              format="YYYY-MM-DD"
              minDate={minDate}
              maxDate={maxDate}
              plugins={[
                <Footer
                  position="top"
                  names={{
                    selectedDates: "Flight information:",
                    from: "Departure date:",
                    to: "Return date:",
                    selectDate: "select",
                    close: "Close",
                    separator: ",",
                  }}
                />
              ]}
            /> */}
          </Grid >
          <Grid item xs={12} md={3}>
            <DatePicker
              range
              render={<CustomInput label="Shipment Date" />}
              value={shippingDateValue}
              containerStyle={{ display: "block" }}
              onChange={dateObjects => {
                setShippingDateValue(dateObjects);
                setpageNo(1);
              }}
              rangeHover
              dateSeparator=" to "
              plugins={[<DatePanel />]}
            />
          </Grid>
          {/* <Grid item xs={6}>
            <Box
              component="fieldset"
              borderColor="transparent"
              className="padding-0 "
              style={{ margin: "20px 0px" }}
            >
              <InputLabel
                htmlFor="component-simple"
                style={{ color: "#424242", marginBottom: "40px" }}
              >
                Invoice Age
              </InputLabel>
              <FormControl className="form-width-70 sliderclass">
                <Typography
                  style={{
                    textAlign: "right",
                    marginTop: "-20px",
                    visibility: "hidden",
                  }}
                >
                  {" "}
                  {2}
                </Typography>

                <Slider
                  defaultValue={0}
                  aria-labelledby="discrete-slider-always"
                  valueLabelDisplay="on"
                  step={1}
                  marks={followersMarks1}
                  min={0}
                  max={180}
                  onChange={(event, value) => {
                    setInvoiceDateInterval(value);
                  }}
                  onMouseUp={(event) => {
                    setloader(true)
                    setTimeout(() => {
                      fetchInvoicesGrid();
                    }, 1000);
                  }}
                  className="MuiOutlinedInput"
                  ariaLabelledBy="non-linear-slider"
                  disabled={disabled}
                />
                <FormHelperText className="color-BCBCBC">
                  (Ex: 15 days, Payment pending is greater than or equal to 15
                  days )
                </FormHelperText>
              </FormControl>
            </Box>
          </Grid> */}
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="formControl">
              <InputLabel
                id="demo-simple-select-outlined-label"
                className="font-14"
                style={{ top: "-4px" }}
              >
                Memo Invoice Status
              </InputLabel>
              <Select
                style={{ height: "45px", color: invoiceTypeFilter === "invoice" ? "#bbb" : "black", background: invoiceTypeFilter === "invoice" ? "#ccc" : "#fff" }}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                label="Memo Invoice Status"
                defaultValue={memoInvoiceStatusFilter}
                onChange={onmemoInvoiceStatusFilter}
                disabled={disabled || (invoiceTypeFilter === "invoice")}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Open">Open </MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl
              className="form-width-99"
              onSubmit={(e) => {
                e.preventDefault();
                fetchInvoicesGrid();
              }}
            >
              <div>
                <Paper
                  component="form"
                  sx={{ p: "2px 4px", display: "flex", alignItems: "center" }}
                  style={{ height: "50px" }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search Customer Name / Business Name / Invoice Number / Serial Number"
                    inputProps={{
                      "aria-label": "Search Customer Name / Business Name / Invoice Number / Serial Number",
                    }}
                    onChange={(e) => {
                      setSearchKeyword(e.target.value);
                      if (!e.target.value) {
                        setpageNo(1);
                        setRows([]);
                        fetchInvoicesGrid(1, "", false);
                      }
                    }}
                    onKeyPress={handleEnterEvent}
                    value={searchKeyword}
                    endAdornment={endAdornment()}
                    disabled={disabled}
                  />
                </Paper>
              </div>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="fieldset"
              borderColor="transparent"
              className="padding-0 invoice-amount-slider"
            //  style={{ marginTop: "20px" }}
            >
              <Typography
              // variant="subtitle1"
              // style={{ marginBottom: "10px", color:"#888", fontWeight: "600px" }}
              >
                <b style={{ marginBottom: "10px", fontSize: "16px" }}>Invoice Amount</b>
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mt: 1,
                }}
              >
                {/* MIN */}
                <Box textAlign="center">
                  <Typography variant="body2" style={{ marginRight: "150px" }}>
                    MIN ($)
                  </Typography>
                  <InputBase
                    value={amountRange[0] === "" ? "" : amountRange[0]}
                    onChange={handleMinInputChange}
                    inputProps={{
                      type: "number",
                      type: "number",
                    }}
                    sx={{
                      width: 200,
                      height: 40,
                      border: "1px solid #999",
                      borderRadius: "4px",
                      textAlign: "center",
                      fontSize: "0.95rem",
                      px: 1,
                      // "& input": {
                      //   textAlign: "center",
                      // },
                      "&:hover": {
                        borderColor: "#666",
                      },
                      "&:focus-within": {
                        borderColor: "#333",
                        boxShadow: "0 0 2px #888",
                      },
                    }}
                  />
                </Box>&emsp;
                <Typography
                  variant="h6"
                  sx={{
                    mx: 1,
                    color: "#555",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  _
                </Typography>&emsp;
                {/* MAX */}
                <Box textAlign="center">
                  <Typography variant="body2" style={{ marginRight: "145px" }}>
                    MAX ($)
                  </Typography>
                  <InputBase
                    value={amountRange[1] === "" ? "" : amountRange[1]}
                    onChange={handleMaxInputChange}
                    inputProps={{
                      type: "number",
                    }}
                    sx={{
                      width: 200,
                      height: 40,
                      border: "1px solid #999",
                      borderRadius: "4px",
                      textAlign: "center",
                      fontSize: "0.95rem",
                      px: 1,
                      // "& input": {
                      //   textAlign: "center",
                      // },
                      "&:hover": {
                        borderColor: "#666",
                      },
                      "&:focus-within": {
                        borderColor: "#333",
                        boxShadow: "0 0 2px #888",
                      },
                    }}
                  />
                </Box>
              </Box>
              {/* <Slider
              value={amountRange}
              aria-labelledby="discrete-slider-always"
              getAriaValueText={valueAmountRangeFormat}
              valueLabelDisplay="on"
              slots={{ valueLabel: RectValueLabel }}
              step={5}
              marks={AmountRangeObj}
              min={0}
              max={100001}
              style={{ marginLeft: "10px"}}
              onChange={handleAmountRangeChange}
              onChangeCommitted={() => {
                fetchData();
              }}
              ariaLabelledBy="non-linear-slider"
           /> */}
            </Box>
          </Grid>
          <Grid item xs={12} md={3}></Grid>
          <Grid item xs={12} md={12}></Grid>
          {
            !loader ?
              <>
                <Grid item xs={12} md={6}>
                  <Box display="flex" flexDirection="column" gap={1} mb={2}>
                    <Box display="flex" flexDirection="row" alignItems="center">
                      <Typography variant="h6"># of Invoices : </Typography>&nbsp;
                      <Typography variant="h6"> {totalDetails?.totalActiveCount || 0} </Typography>
                    </Box>
                    {(totalDetails && totalDetails?.totalVoidCount > 0) &&
                      <Box display="flex" flexDirection="row" alignItems="center" style={{ marginBottom: "15px" }}>
                        <Typography variant="p"># of Void Invoices : </Typography>&nbsp;
                        <Typography variant="p"> {totalDetails?.totalVoidCount || 0} </Typography>
                      </Box>}
                    {showBulkVoidCheckboxes && selectedInvoicesForVoid.length > 0 && (
                      <Box display="flex" flexDirection="row" alignItems="center">
                        <Typography variant="p" style={{ fontSize: "15px", fontWeight: 600 }}># of selected Invoices : </Typography>&nbsp;
                        <Typography variant="p" style={{ fontSize: "15px", fontWeight: 600 }}> {selectedInvoicesForVoid.length} </Typography>
                      </Box>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box display="flex" flexDirection="column" gap={1} alignItems={{ xs: "flex-start", md: "flex-end" }} mb={2}>
                    <Box display="flex" flexDirection="row" alignItems="center">
                      <Typography variant="h6">Total Invoice Value : </Typography>&nbsp;
                      <Typography variant="h6"> $ {totalDetails?.totalInvoiceSum || 0} </Typography>
                    </Box>
                    {(totalDetails?.totalVoidSum > 0) &&
                      <Box display="flex" flexDirection="row" alignItems="center">
                        <Typography variant="p">Total Void Invoice Value : </Typography>&nbsp;
                        <Typography variant="p"> $ {totalDetails?.totalVoidSum || 0} </Typography>
                      </Box>}
                    {showBulkVoidCheckboxes && selectedInvoicesForVoid.length > 0 && (
                      <Box
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        gap="16px"
                        mt={0.5}>
                        <Button
                          variant="contained"
                          onClick={handleProfitCalculate}
                          startIcon={<TrendingUpIcon />}
                          className="text-capitalize primary-bg color-white"
                          style={{ marginRight: "15px" }}
                        >
                          Profit
                        </Button>
                        {showBulkUpdatePaymentButton && (
                          <Button
                            variant="contained"
                            onClick={handleOpenBulkUpdatePayment}
                            startIcon={<PaymentIcon />}
                            className="text-capitalize primary-bg color-white"
                            style={{ marginRight: "15px" }}
                          >
                            Update Payment
                          </Button>
                        )}
                        <Button
                          variant="contained"
                          startIcon={<BlockIcon />}
                          onClick={handleBulkVoidClick}
                          disabled={!canBulkVoidSelected}
                          className="text-capitalize primary-bg color-white"
                        >
                          {canBulkVoidSelected &&
                            voidableSelectedInvoices.length !== selectedInvoicesForVoid.length
                            ? `Void Invoices (${voidableSelectedInvoices.length})`
                            : `Void Invoice${selectedInvoicesForVoid.length > 1 ? "s" : ""}`}
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Grid>
              </> : ''}
        </Grid >
        {loader && pageNo === 1 ? (
          <div className="d-spinner">
            <SpinnerRoundFilled
              size={51}
              thickness={125}
              speed={80}
              color="rgba(57, 107, 172, 1)"
              className="spp"
              enabled={loader}
            />
          </div>
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }} >
            <TableContainer style={{ overflowY: "hidden" }}>
              <InfiniteScroll
                dataLength={rows?.length || 0}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={
                  (hasMore && totalInvoicePages > 1) ? (
                    <div style={{ margin: "25px auto", width: "100px", textAlign: "center" }}>
                      <Loader type="Puff" color="#9F7C50" height={50} width={50} />
                      <h4 className="color-p">Loading...</h4>
                    </div>
                  ) : null
                }
              >
                <Table>
                  <Tooltip title="Scroll to top" arrow>
                    <div style={{
                      position: "fixed",
                      bottom: "90px",
                      right: "45px"
                    }}>
                      <ScrollUpButton
                        EasingType="easeInOutBounce"
                        ShowAtPosition={1000}
                        AnimationDuration={500}
                        style={{
                          backgroundColor: '#CEA05F',
                          borderRadius: '50%',
                          padding: "10px",
                          border: "none",
                          fill: "#fff",
                          bottom: "85px"
                        }}
                      />
                    </div>
                  </Tooltip>
                  <TableHead>
                    <TableRow>
                      {showBulkVoidCheckboxes && (
                        <StyledTableCell padding="checkbox">
                          <Checkbox
                            color="default"
                            indeterminate={someSelectableSelected && !allSelectableSelected}
                            checked={allSelectableSelected}
                            onChange={(e) => handleSelectAllSelectable(e.target.checked)}
                            disabled={selectableRowsOnPage.length === 0}
                            style={{ color: 'white' }}
                          />
                        </StyledTableCell>
                      )}
                      {invoiceTableColumns.map(({ id, label }) => (
                        <StyledTableCell key={id}>
                          <TableSortLabel
                            active={sortingColumn === id}
                            direction={sortingColumn === id ? sortingOrder : "asc"}
                            onClick={() => handleSort(id)}
                            style={{ color: "white", whiteSpace: label === "Invoice #" ? "nowrap" : "normal" }}
                          >
                            {label}
                          </TableSortLabel>
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows && rows.length ? (
                      <>
                        {rows
                          .map((row) => {
                            const inputRow = row;
                            return (
                              <StyledTableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={row.code}
                              >
                                {showBulkVoidCheckboxes && (
                                  <TableCell padding="checkbox">
                                    {isInvoiceSelectable(row) && (
                                      <Checkbox
                                        color="primary"
                                        checked={selectedInvoicesForVoid.some((item) => item.id === row.id)}
                                        onChange={() => handleToggleInvoiceSelection(row)}
                                      />
                                    )}
                                  </TableCell>
                                )}
                                {invoiceTableColumns.map((column) => (
                                  <React.Fragment key={column.id}>
                                    {column.id !== "actions" && (
                                      <TableCell align={column.align} className="text-capitalize">
                                        {renderColumnContent(column, row)}
                                      </TableCell>
                                    )}
                                    {column.id === "actions" && (
                                      <TableCell align={column.align}>{renderActionsMenu(row, accessData)}</TableCell>
                                    )}
                                  </React.Fragment>
                                ))}
                              </StyledTableRow>
                            );
                          })}{" "}
                      </>
                    ) : (
                      <TableCell colspan={12} style={{ textAlign: "center" }}>
                        <Typography variant="h6" className="color-BCBCBC">
                          No Records Found
                        </Typography>
                      </TableCell>
                    )}
                  </TableBody>
                </Table>
              </InfiniteScroll>
            </TableContainer>
            {/* <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={rows?.length}
              SelectProps={{
                native: true
              }}
              limit={limit}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
          </Paper>
        )}
        {
          openInvoiceTransactionModal && (
            <InvoiceTransactionModal
              open={openInvoiceTransactionModal}
              handleClose={handleCloseAction}
              invoice={selectedInvoice}
              getPaymentHistory={props.getPaymentHistory}
              canVoidPayment={canVoidPayment}
              canEditPayment={canEditPayment}
              onPaymentVoided={(results) => {
                const updatedInvoice =
                  results?.invoice || results?.data?.invoice || null;
                if (updatedInvoice) {
                  setSelectedInvoice((prev) =>
                    prev ? { ...prev, ...updatedInvoice } : prev
                  );
                  setRows((prev) =>
                    prev.map((row) =>
                      row.id === updatedInvoice.id
                        ? { ...row, ...updatedInvoice }
                        : row
                    )
                  );
                }
                fetchData(null, 1, false);
              }}
              onPaymentEdited={(results) => {
                const updatedInvoice =
                  results?.invoice || results?.data?.invoice || null;
                if (updatedInvoice) {
                  setSelectedInvoice((prev) =>
                    prev ? { ...prev, ...updatedInvoice } : prev
                  );
                  setRows((prev) =>
                    prev.map((row) =>
                      row.id === updatedInvoice.id
                        ? { ...row, ...updatedInvoice }
                        : row
                    )
                  );
                }
                fetchData(null, 1, false);
              }}
            />
          )
        }
        {
          openMemoInvoiceHistoryModal && (
            <MemoHistoryModal
              open={openMemoInvoiceHistoryModal}
              handleClose={handleCloseAction}
              memoInvoice={selectedInvoice}
            />
          )
        }
        {
          openCancelModal && (
            <CancelInvoiceModal
              open={openCancelModal}
              handleClose={handleCloseAction}
              invoice={bulkVoidInvoices.length ? null : selectedInvoice}
              invoices={bulkVoidInvoices.length ? bulkVoidInvoices : null}
              getInvoices={fetchData}
              onVoidComplete={() => setSelectedInvoicesForVoid([])}
            />
          )
        }
        {
          openProfitModal && (
            <ProfitModal
              open={openProfitModal}
              handleClose={handleCloseAction}
              invoice={profitInvoices.length ? null : selectedInvoice}
              invoices={profitInvoices.length ? profitInvoices : null}
              filterPayload={profitFilters}
            />
          )
        }
        {
          <Dialog
            open={showQboWarning}
            onClose={() => setShowQboWarning(false)}
          >
            <DialogTitle>Warning!</DialogTitle>

            <DialogContent>
              <p>
                Changes made may NOT be reflected in Quick Books Online,
                make sure to manually enter those changes to keep clean accounting records
              </p>
              <div style={{ marginLeft: "350px", display: "flex", gap: "12px", marginTop: "20px" }}>
                <Button
                  onClick={() => { setShowQboWarning(false); setPendingAction(null); }}
                  variant="outlined"
                >
                  Cancel
                </Button>

                <Button
                  onClick={() => {
                    setShowQboWarning(false);
                    if (pendingAction === 'UPDATE') {
                      handleTransactionModal("SHIPPING-INFO", selectedInvoice?.paymentstatus);
                    } else if (pendingAction === 'VOID') {
                      setBulkVoidInvoices([]);
                      setCancelModal(true);
                    } else if (pendingAction === 'BULK_VOID') {
                      setBulkVoidInvoices(voidableSelectedInvoices);
                      setCancelModal(true);
                    }
                    setPendingAction(null);
                  }}
                  variant="contained"
                  style={{ background: "#000", color: "#fff" }}
                >
                  Proceed
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        }
        {
          <QboConfig
            open={openQBOConfigModal}
            handleClose={handleCloseQBO}
            invoiceId={invoiceId}
            accountId={accountId}
            onQboSuccess={() => {
              setpageNo(1);
              fetchInvoicesGrid(null, 1);
            }}
          />
        }
        {
          <QboInvoice
            open={openQBOInvoiceModal}
            handleClose={handleCloseQBOInvoice}
            invoiceId={invoiceId}
            accountId={accountId}
            onQboSuccess={() => {
              setpageNo(1);
              fetchInvoicesGrid(null, 1);
            }}
          />
        }
        <Dialog
          open={dealerPushConfirmOpen}
          onClose={() => setDealerPushConfirmOpen(false)}
          aria-labelledby="dealer-push-dialog"
        >
          <DialogTitle id="dealer-push-dialog">Push Inventory to Dealer?</DialogTitle>
          <DialogContent>
            <p style={{ marginBottom: 16, fontSize: 14, color: "#454545" }}>
              Since the customer is a registered WatchOps Dealer, would you like to push the inventory items from this invoice directly to the buyer's dealer account?
            </p>
            <Box style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <Button
                variant="outlined"
                onClick={handleNoClick}
                // onClick={() => handleDealerPushDecision(false)}
                style={{ background: "#fff", color: "#000" }}
              >
                No
              </Button>
              <Button
                variant="text"
                onClick={() => handleDealerPushDecision(true)}
                style={{ background: "#000", color: "#fff" }}
              >
                Yes
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
        {
          viewInvoiceModal && (
            <ViewInvoicemodel
              open={viewInvoiceModal}
              handleClose={handleCloseAction}
              // invoiceid={selectedInvoice}
              invoiceid={{
                id: selectedInvoice.id,
                memoid: selectedInvoice?.invoicetype === "Memo Invoice"
                  ? selectedInvoice.id
                  : null,
                invoicetype: selectedInvoice?.invoicetype
              }}
            />
          )
        }
        {
          openShippingInfoModal && (
            <ShippingInfoUpdateModal
              open={openShippingInfoModal}
              handleClose={handleCloseAction}
              invoice={selectedInvoice}
              paymentStatus={checkPaymentStatus}
              fetchInvoicesGrid={fetchInvoicesGrid}
              openQboInvoice={(id, accountId) => {
                setInvoiceId(id);
                setAccountId(accountId);
                setOpenQBOInvoiceModal(true);
              }}
            />
          )
        }
        <Modal
          open={showBulkUpdatePaymentModal}
          onClose={handleCloseBulkUpdatePayment}
          aria-labelledby="bulk-update-payment-modal-title"
        >
          <Box sx={{
            ...style, width: bulkPaymentMethod === "Trade" ? 560 : 460,
            maxHeight: "90vh",
            overflowY: "auto",
          }}>
            <Typography id="bulk-update-payment-modal-title" variant="h6" component="h2">
              Bulk Payment Update
            </Typography>
            <Typography variant="subtitle2" style={{ marginTop: 8 }}>
              Total Balance Amount: ${formatInvoiceDisplayAmount(bulkTotalBalance)}
            </Typography>
            <Box style={{ margin: "10px 0 15px", display: "flex", flexWrap: "wrap", gap: 6 }}>
              {selectedInvoicesForVoid.map((inv) => (
                <span
                  key={inv.id}
                  style={{
                    background: "#f0f0f0",
                    borderRadius: 4,
                    padding: "3px 8px",
                    fontSize: "0.85rem",
                  }}
                >
                  {inv.invoicenumber}
                </span>
              ))}
            </Box>
            <form onSubmit={submitBulkUpdatePayment}>
              <FormControl
                className="form-width-100 margin-t-b-20 margin-p-b-20"
                style={{ marginTop: "15px" }}
              >
                <InputLabel htmlFor="bulk-payment-amount" className="color-BCBCBC">
                  Amount
                </InputLabel>
                <Input
                  id="bulk-payment-amount"
                  type="text"
                  value={bulkPaymentAmount}
                  onChange={(e) => {
                    setBulkPaymentAmount(e.target.value);
                    if (bulkPaymentAmountError) setBulkPaymentAmountError("");
                  }}
                />
                {/* <FormHelperText className="error-o">{bulkPaymentAmountError}</FormHelperText> */}
              </FormControl>
              <FormControl
                className="form-width-100 margin-t-b-20 margin-p-b-20"
                style={{ marginTop: "15px" }}
              >
                <FormLabel style={{ color: "#C2BCBC" }}>Date</FormLabel>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="bulk-payment-date"
                    format="MM/dd/yyyy"
                    value={bulkPaymentDate}
                    maxDate={new Date()}
                    onChange={(date, e) => {
                      setBulkPaymentDate(e);
                      if (bulkPaymentDateError) setBulkPaymentDateError("");
                    }}
                    isClearable
                    KeyboardButtonProps={{ "aria-label": "change date" }}
                    placeholder="MM/DD/YYYY"
                    onPaste={(event) => event.preventDefault()}
                    helperText={bulkPaymentDateError}
                    error={!!bulkPaymentDateError}
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
              <FormControl fullWidth style={{ marginTop: "15px" }}>
                <InputLabel htmlFor="bulk-payment-method" className="color-BCBCBC">
                  Payment Method
                </InputLabel>
                <Select
                  id="bulk-payment-method"
                  value={bulkPaymentMethod}
                  onChange={onBulkPaymentMethodChange}
                  label="Payment Method"
                >
                  {bulkPaymentMethodOptions.map((value, index) => (
                    <MenuItem key={index} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText className="error-o">{bulkPaymentMethodError}</FormHelperText>
              </FormControl>
              <FormControl
                className="form-width-100 margin-t-b-20 margin-p-b-20"
                style={{ marginTop: "15px" }}
              >
                <InputLabel htmlFor="bulk-payment-details" className="color-BCBCBC">
                  Payment Details
                </InputLabel>
                <Input
                  id="bulk-payment-details"
                  value={bulkPaymentDetails}
                  onChange={(e) => setBulkPaymentDetails(e.target.value)}
                />
              </FormControl>
              {bulkPaymentMethod === "Trade" && (
                <>
                  <FormControlLabel
                    onClick={() => setInventoryError("")}
                    control={
                      <Checkbox
                        checked={tradeInventory}
                        onChange={onChangeOfCheckBoxInventory}
                      />
                    }
                    label={
                      <span style={{ color: "black", fontSize: "14px" }}>
                        {!tradeInventory
                          ? "Use an Existing Inventory for Trade"
                          : "Create New Trade Inventory"}
                      </span>
                    }
                  />
                  {inventoryError && (
                    <FormHelperText className="error-o">{inventoryError}</FormHelperText>
                  )}

                  {!tradeInventory && (
                    <FormControl
                      className="form-width-100 space-marign-bottom-10"
                      style={{ minWidth: "100%", marginTop: 10 }}
                    >
                      <Controller
                        name="bulkModelAndSerial"
                        control={control}
                        rules={{ required: !currentItem }}
                        render={({ field }) => {
                          const safeOptions = Array.isArray(invoiceListData)
                            ? invoiceListData
                              .filter(Boolean)
                              .filter((opt) => {
                                const invType = opt.inventorytype ?? opt.inventory_type ?? null;
                                return !(invType === "4" || invType === 4);
                              })
                              .filter((opt) => opt?.sold === 0 || opt?.sold === 1)
                            : [];
                          const selectedValue =
                            !tradeInventory && field.value
                              ? safeOptions.find(
                                (opt) => opt.inventoryid === field.value.inventoryid
                              ) || null
                              : null;

                          const handleInventorySelect = (val) => {
                            if (!val) {
                              handleClearInventory();
                              field.onChange(null);
                              setCurrentItem(null);
                              return;
                            }
                            field.onChange(val);
                            setCurrentItem(val);
                            setInventoryID(val.inventoryid);
                            setInventoryError("");
                            setType(val.type);
                            setSelectedInventoryModel(val.model);
                            setSelectedInventorySerial(val.serialno);
                            setSelectedInventoryPrice(val.purchaseprice);
                            setTradeInventoryPrice(val.purchaseprice);
                            setSelectedInventoryModelName(
                              val?.technical_details?.product_name || ""
                            );
                            setSelectInventoryModelNumber(
                              val?.technical_details?.model_number || ""
                            );
                            setSelectedInventoryCategory(val?.category || "");
                          };

                          return (
                            <Autocomplete
                              options={safeOptions}
                              value={selectedValue}
                              inputValue={!tradeInventory ? searchText : ""}
                              disableClearable={false}
                              clearOnEscape
                              openOnFocus={false}
                              onInputChange={(event, newValue) => {
                                if (tradeInventory) return;
                                setSearchText(newValue);
                              }}
                              onChange={(event, val) => handleInventorySelect(val)}
                              getOptionDisabled={(option) => {
                                const products = selectedInvoicesForVoid.flatMap(
                                  (inv) => inv?.invoiceproductdetails?.product || []
                                );
                                return products.some(
                                  (product) =>
                                    Number(product.inventoryid) === Number(option.inventoryid)
                                );
                              }}
                              getOptionLabel={(option) =>
                                option
                                  ? `${option.model ?? ""} | ${option.serialno ?? "---"} | ${option.inventoryid ?? ""
                                  }`
                                  : ""
                              }
                              filterOptions={(options, state) => {
                                const input = state.inputValue?.toLowerCase() || "";
                                return options.filter(
                                  (option) =>
                                    option &&
                                    (option.model?.toLowerCase().includes(input) ||
                                      option.serialno?.toLowerCase().includes(input) ||
                                      String(option.inventoryid).includes(input))
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  label="Search Model | Serial No | Inventory ID"
                                  placeholder="Search Model | Serial No | Inventory ID"
                                  InputProps={{
                                    ...params.InputProps,
                                    readOnly: tradeInventory || !!currentItem,
                                  }}
                                />
                              )}
                            />
                          );
                        }}
                      />
                    </FormControl>
                  )}

                  {!tradeInventory && inventoryid && (
                    <table style={{ width: "100%", marginTop: 8, borderCollapse: "collapse" }}>
                      <tbody>
                        <TableRow>
                          <TableCell colSpan={4} style={{ textAlign: "left", paddingLeft: 0 }}>
                            TYPE
                          </TableCell>
                          <TableCell colSpan={3} style={{ paddingRight: 0 }}>
                            <input
                              className="form-width-100"
                              type="text"
                              placeholder="TYPE"
                              style={{ height: "30px" }}
                              value={
                                resolvedType === "misc_product"
                                  ? "Misc Product"
                                  : resolvedType === "misc_watch"
                                    ? "Misc Watch"
                                    : "Standard Watch"
                              }
                              readOnly
                            />
                          </TableCell>
                        </TableRow>
                        {uiType === "standard_watch" && (
                          <TableRow>
                            <TableCell colSpan={4} style={{ textAlign: "left", paddingLeft: 0 }}>
                              MODEL
                            </TableCell>
                            <TableCell colSpan={3} style={{ paddingRight: 0 }}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="MODEL"
                                style={{ height: "30px" }}
                                value={tradeModel || ""}
                                readOnly
                              />
                            </TableCell>
                          </TableRow>
                        )}
                        {resolvedType === "misc_product" && (
                          <TableRow>
                            <TableCell colSpan={4} style={{ textAlign: "left", paddingLeft: 0 }}>
                              MISC CATEGORY
                            </TableCell>
                            <TableCell colSpan={3} style={{ paddingRight: 0 }}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="MISC CATEGORY"
                                style={{ height: "30px" }}
                                value={tradeMiscCategory || ""}
                                readOnly
                              />
                            </TableCell>
                          </TableRow>
                        )}
                        {(resolvedType === "misc_watch" || resolvedType === "misc_product") && (
                          <TableRow>
                            <TableCell colSpan={4} style={{ textAlign: "left", paddingLeft: 0 }}>
                              MODEL NAME
                            </TableCell>
                            <TableCell colSpan={3} style={{ paddingRight: 0 }}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="MODEL NAME"
                                style={{ height: "30px" }}
                                value={tradeModelName || ""}
                                readOnly
                              />
                            </TableCell>
                          </TableRow>
                        )}
                        <TableRow>
                          <TableCell colSpan={4} style={{ textAlign: "left", paddingLeft: 0 }}>
                            SERIAL NUMBER
                          </TableCell>
                          <TableCell colSpan={3} style={{ paddingRight: 0 }}>
                            <input
                              className="form-width-100"
                              type="text"
                              placeholder="SERIAL NUMBER"
                              style={{ height: "30px" }}
                              value={tradeSerialNumber || selectedInventorySerial || ""}
                              readOnly
                            />
                          </TableCell>
                        </TableRow>
                        {resolvedType === "misc_product" && (
                          <TableRow>
                            <TableCell colSpan={4} style={{ textAlign: "left", paddingLeft: 0 }}>
                              MODEL NUMBER
                            </TableCell>
                            <TableCell colSpan={3} style={{ paddingRight: 0 }}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="MODEL NUMBER"
                                style={{ height: "30px" }}
                                value={tradeModelNumber || ""}
                                readOnly
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      </tbody>
                    </table>
                  )}

                  {tradeInventory && (
                    <>
                      <FormControl fullWidth style={{ marginTop: "15px" }}>
                        <InputLabel className="color-BCBCBC">Type</InputLabel>
                        <Select
                          value={watchType}
                          onChange={(e) => setWatchType(e.target.value)}
                          label="Type"
                        >
                          <MenuItem value="standard_watch">Standard Watch</MenuItem>
                          <MenuItem value="misc_watch">Misc Watch</MenuItem>
                          <MenuItem value="misc_product">Misc Product</MenuItem>
                        </Select>
                      </FormControl>

                      {watchType === "standard_watch" && (
                        <>
                          <FormControl
                            className="form-width-100 margin-t-b-20 margin-p-b-20"
                            style={{ marginTop: "15px" }}
                          >
                            <InputLabel
                              className="color-BCBCBC"
                              shrink={!!modelNo || undefined}
                            >
                              Model
                            </InputLabel>
                            <Input
                              id="bulk-trade-model"
                              inputProps={{ type: "text" }}
                              autoComplete="off"
                              value={modelNo || ""}
                              onChange={(e) => handleSearch(e, "modelNumber")}
                              endAdornment={
                                searchObj?.searchVal?.length > 0 ? (
                                  <InputAdornment position="end">
                                    {searchLoading ? (
                                      <CircularProgress size={20} />
                                    ) : (
                                      <IconButton
                                        onClick={() => {
                                          setAnchorEl(null);
                                          setModelErrorText("");
                                          setPropsModelList([]);
                                          setModel("");
                                          setSearchLoading(false);
                                          setSearchObj((prevState) => ({
                                            ...prevState,
                                            searchVal: "",
                                            searchText: "",
                                            from: "trade",
                                          }));
                                        }}
                                        color="primary"
                                        size="small"
                                      >
                                        <ClearIcon />
                                      </IconButton>
                                    )}
                                  </InputAdornment>
                                ) : null
                              }
                            />
                            <FormHelperText className="error-o">{modelErrorText}</FormHelperText>
                          </FormControl>
                          {!searchLoading &&
                            searchObj?.searchVal?.length > 0 &&
                            searchObj?.column === "modelNumber" &&
                            propsModelList.length > 0 && (
                              <List
                                className="searchlist MuiPaper-elevation1 inventrysearch"
                                style={{ listStyle: "none" }}
                              >
                                {propsModelList.map((item, idx) => (
                                  <div key={idx}>
                                    <ListItem
                                      onClick={() => handleSelection(item, "model")}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <ListItemIcon>
                                        <IconButton color="primary">
                                          <img
                                            width="45"
                                            src={item.imagepaths?.images?.toString().split(",")[0]}
                                            alt="Product"
                                          />
                                        </IconButton>
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={`${item.brandname} ${item.model}`}
                                        secondary={item.family}
                                        style={{ marginTop: "25px", marginLeft: "80px" }}
                                      />
                                    </ListItem>
                                    <Divider variant="inset" component="li" />
                                  </div>
                                ))}
                              </List>
                            )}
                        </>
                      )}

                      {watchType === "misc_product" && (
                        <FormControl fullWidth style={{ marginTop: "15px" }}>
                          <InputLabel className="color-BCBCBC">Misc Category</InputLabel>
                          <Select
                            value={tradeMiscCategory || ""}
                            onChange={(e) => setTradeMiscCategory(e.target.value)}
                            label="Misc Category"
                          >
                            <MenuItem value="watch related accessories">Watch Related Accessories</MenuItem>
                            <MenuItem value="apparel">Apparel</MenuItem>
                            <MenuItem value="watch parts">Watch Parts</MenuItem>
                            <MenuItem value="jewelry">Jewelry</MenuItem>
                            <MenuItem value="stones">Stones</MenuItem>
                            <MenuItem value="hand bags">Hand Bags</MenuItem>
                            <MenuItem value="wallets">Wallets</MenuItem>
                            <MenuItem value="bag related accessories">Bag Related Accessories</MenuItem>
                            <MenuItem value="service watches">Service Watches</MenuItem>
                            <MenuItem value="others">Others</MenuItem>
                          </Select>
                          <FormHelperText className="error-o">{miscCategoryErrorText}</FormHelperText>
                        </FormControl>
                      )}

                      {(watchType === "misc_watch" || watchType === "misc_product") && (
                        <FormControl
                          className="form-width-100 margin-t-b-20 margin-p-b-20"
                          style={{ marginTop: "15px" }}
                        >
                          <InputLabel className="color-BCBCBC">Model Name</InputLabel>
                          <Input
                            value={tradeModelName || ""}
                            onChange={(e) => setTradeModelName(e.target.value)}
                          />
                          <FormHelperText className="error-o">{modelNameErrorText}</FormHelperText>
                        </FormControl>
                      )}

                      <FormControl
                        className="form-width-100 margin-t-b-20 margin-p-b-20"
                        style={{ marginTop: "15px" }}
                      >
                        <InputLabel className="color-BCBCBC" shrink={!!serialNo}>
                          Serial Number
                        </InputLabel>
                        <Input value={serialNo ?? ""} onChange={onSerialNoChange} />
                        <FormHelperText className="error-o">{serialnoErrorText}</FormHelperText>
                      </FormControl>

                      {watchType === "misc_product" && (
                        <FormControl
                          className="form-width-100 margin-t-b-20 margin-p-b-20"
                          style={{ marginTop: "15px" }}
                        >
                          <InputLabel className="color-BCBCBC">Model Number</InputLabel>
                          <Input
                            value={tradeModelNumber || ""}
                            onChange={(e) => setTradeModelNumber(e.target.value)}
                          />
                          <FormHelperText className="error-o">{modelNumberErrorText}</FormHelperText>
                        </FormControl>
                      )}
                    </>
                  )}
                </>
              )}

              {(bulkPaymentAmountError) && (
                <FormHelperText className="error-o" style={{ textAlign: "left", marginTop: "15px" }}>
                  {bulkPaymentAmountError}
                </FormHelperText>
              )}

              <Box style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
                <Button
                  variant="outlined"
                  onClick={handleCloseBulkUpdatePayment}
                  disabled={bulkPaymentSubmitting}
                  style={{ background: "#fff", color: "#000" }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={bulkPaymentSubmitting}
                  className="text-capitalize primary-bg color-white"
                >
                  {bulkPaymentSubmitting ? "Submitting..." : "Submit"}
                </Button>
              </Box>
            </form>
          </Box>
        </Modal>
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            ></Typography>
            <form key={3} onSubmit={(e) => submitPaymentForm(e)}>
              {paymentStatus === "Partially Paid" ? (
                <div style={{ display: "flex", flexDirection: "column", float: "left" }}>
                  <div>
                    <Typography variant="subtitle2">
                      Total Invoice Amount: ${totalAmt || "-"}
                    </Typography>
                  </div>
                  <div >
                    <Typography variant="subtitle2">
                      Paid Amount: ${paidAmount ? parseFloat(paidAmount).toFixed(2) : "-"}
                    </Typography>

                  </div>
                </div>
              ) : null
              }
              <FormControl fullWidth style={{ marginTop: "10px" }}></FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="component-simple" className="color-BCBCBC">
                  Payment Status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={onPaymentStatusChange}
                  defaultValue={paymentStatus}
                  label="Payment Status"
                >
                  {
                    paymentStatus == "Partially Paid" ? null : <MenuItem value="Not Paid">Select</MenuItem>
                  }
                  <MenuItem value="Partially Paid">Partially Paid</MenuItem>
                  <MenuItem value="Fully Paid">Fully Paid</MenuItem>
                </Select>

                {/* <FormHelperText className="error-o">{this.state.onGenderErrorText}</FormHelperText> */}
              </FormControl>
              {paymentStatus &&
                paymentStatus !== "Not Paid" &&
                paymentStatus !== "Trade" ? (
                <div>
                  <FormControl
                    className="form-width-100 margin-t-b-20 margin-p-b-20"
                    style={{ marginTop: "15px" }}
                  >
                    {disableAmount || amount !== null ? (
                      <InputLabel
                        htmlFor="component-simple"
                        shrink={true}
                        className="color-BCBCBC"
                      >
                        Amount
                      </InputLabel>
                    ) : (
                      <InputLabel
                        htmlFor="component-simple"
                        className="color-BCBCBC"
                      >
                        Amount
                      </InputLabel>
                    )}
                    <Input
                      id="component-simple"
                      key="amount"
                      type="text"
                      disabled={disableAmount}
                      value={amount}
                      inputProps={{
                        step: any,
                        //min: 0.01,
                      }}
                      // onInput={(e)=>console.log(parseFloat(e.target.value).toFixed(2))}
                      onChange={onAmountChange}
                    />
                    <FormHelperText className="error-o">
                      {errRemainingAmt}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    className="form-width-100 margin-t-b-20 margin-p-b-20"
                    style={{ marginTop: "15px" }}
                  >
                    <FormLabel style={{ color: "#C2BCBC" }}>Date</FormLabel>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        // className="color-BCBCBC"
                        margin="normal"
                        id="date-picker-dialog"
                        format="MM/dd/yyyy"
                        // disableFuture={true}
                        value={paymentDate}
                        maxDate={new Date()}
                        // minDate={invoiceDate ? invoiceDate : null}
                        onChange={(date, e) => setPaymentdDate(e)}
                        isClearable
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        // TextFieldComponent={TextFieldComponent}
                        placeholder="MM/DD/YYYY"
                        onPaste={(event) => event.preventDefault()}
                        helperText={""}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                  <FormControl fullWidth style={{ marginTop: "15px" }}>
                    <InputLabel
                      htmlFor="component-simple"
                      className="color-BCBCBC"
                    >
                      Payment Method
                    </InputLabel>
                    <Select
                      // disabled={this.state.isDisabled}
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      onChange={onPaymentMethodChange}
                      value={paymentMethod}
                      label="Payment Method"
                    >
                      {paymentContactBased?.length > 0 && [...paymentContactBased]
                        .sort((a, b) => a.localeCompare(b)).map((value, index) => (
                          <MenuItem key={index} value={value}>
                            {value}
                          </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText className="error-o">{paymentMethodErrorText}</FormHelperText>
                  </FormControl>

                  <FormControl
                    className="form-width-100 margin-t-b-20 margin-p-b-20"
                    style={{ marginTop: "15px" }}
                  >
                    <InputLabel
                      htmlFor="component-simple"
                      className="color-BCBCBC"
                    >
                      Payment Details
                    </InputLabel>
                    <Input
                      id="component-simple"
                      value={paymentdetails}
                      onChange={onPaymentDetails}
                    />
                  </FormControl>

                  <FormControl
                    className="form-width-99 margin-t-b-20 margin-p-b-20"
                    style={{ marginTop: "15px" }}
                  >
                    <InputLabel
                      htmlFor="component-simple"
                      className="color-BCBCBC"
                    >
                      Remaining Amount
                    </InputLabel>
                    <Input
                      id="component-simple"
                      // disabled={this.state.isDisabled}
                      readOnly
                      value={remainingAmount}
                      onChange={onRemainingAmountChange}
                    />
                    {/* <FormHelperText className="error-o">{this.state.onBusinessNameErrorText}</FormHelperText> */}
                  </FormControl>
                  <TableRow>
                    {/* {paymentMethod === "Trade" && (
                        <TableCell colSpan={6} style={{ textAlign: "left", paddingLeft: 0, paddingRight: 0 }}>
                           Trade Inventory
                        </TableCell>
                      )} */}
                    {paymentMethod === "Trade" && (
                      <TableCell colSpan={18} style={{ paddingRight: 0, paddingLeft: 0, borderBottom: 0 }}>
                        <FormControlLabel
                          onClick={() => setInventoryError("")}
                          control={
                            <Checkbox
                              checked={tradeInventory}
                              onChange={onChangeOfCheckBoxInventory}
                            />
                          }
                          label={
                            <span style={{ color: "black", fontSize: '14px' }}>
                              {!tradeInventory
                                ? "Use an Existing Inventory for Trade"
                                : "Create New Trade Inventory"}
                            </span>
                          }
                        />
                        {inventoryError && (
                          <FormHelperText className="error-o">
                            {inventoryError}
                          </FormHelperText>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                  {paymentMethod === "Trade" && !tradeInventory && (
                    <TableRow>
                      <TableCell colSpan={18} style={{ padding: 0, borderBottom: 0 }}>
                        <div className="searchInputs">
                          <FormControl className="form-width-100 space-marign-bottom-10" style={{ minWidth: '320px' }}>
                            <Controller
                              name="modelAndSerial"
                              control={control}
                              rules={{ required: !currentItem }}
                              render={({ field, fieldState }) => (
                                <FormControl className="form-width-100 space-marign-bottom-10">
                                  <Controller
                                    name="modelAndSerial"
                                    control={control}
                                    rules={{ required: !currentItem }}
                                    render={({ field }) => {
                                      const safeOptions = Array.isArray(invoiceListData)
                                        ? invoiceListData
                                          .filter(Boolean)
                                          .filter((opt) => {
                                            const invType = opt.inventorytype ?? opt.inventory_type ?? null;
                                            return !(invType === "4" || invType === 4);
                                          })
                                          .filter((opt) => opt?.sold === 0 || opt?.sold === 1)
                                        : [];

                                      const selectedValue =
                                        !tradeInventory && field.value
                                          ? safeOptions.find(
                                            (opt) => opt.inventoryid === field.value.inventoryid
                                          ) || null
                                          : null;

                                      const handleInventorySelect = (val) => {
                                        if (!val) {
                                          handleClearInventory();
                                          field.onChange(null);
                                          setCurrentItem(null);
                                          return;
                                        }

                                        field.onChange(val);
                                        setCurrentItem(val);
                                        setInventoryID(val.inventoryid);
                                        setInventoryError("");
                                        setType(val.type);
                                        setSelectedInventoryModel(val.model);
                                        setSelectedInventorySerial(val.serialno);
                                        setSelectedInventoryPrice(val.purchaseprice);
                                        setTradeInventoryPrice(val.purchaseprice);
                                        setSelectedInventoryModelName(
                                          val?.technical_details?.product_name || ""
                                        );
                                        setSelectInventoryModelNumber(
                                          val?.technical_details?.model_number || ""
                                        );
                                        setSelectedInventoryCategory(val?.category || "");
                                      };

                                      return (
                                        <Autocomplete
                                          options={safeOptions}
                                          value={selectedValue}
                                          inputValue={!tradeInventory ? searchText : ""}
                                          disableClearable={false}
                                          clearOnEscape
                                          openOnFocus={false}
                                          onInputChange={(event, newValue) => {
                                            if (tradeInventory) return;
                                            setSearchText(newValue);
                                          }}
                                          onChange={(event, val) => handleInventorySelect(val)}
                                          getOptionDisabled={(option) => {
                                            const currentInvoice =
                                              rows?.find((row) => row.id === invoiceId) ||
                                              selectedInvoice;
                                            const products = currentInvoice?.invoiceproductdetails?.product || [];
                                            return products.some((product) =>
                                              Number(product.inventoryid) === Number(option.inventoryid)
                                            );
                                          }}
                                          getOptionLabel={(option) =>
                                            option
                                              ? `${option.model ?? ""} | ${option.serialno ?? "---"
                                              } | ${option.inventoryid ?? ""}`
                                              : ""
                                          }
                                          filterOptions={(options, state) => {
                                            const input = state.inputValue?.toLowerCase() || "";
                                            return options.filter(
                                              (option) =>
                                                option &&
                                                (option.model?.toLowerCase().includes(input) ||
                                                  option.serialno?.toLowerCase().includes(input) ||
                                                  String(option.inventoryid).includes(input))
                                            );
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              variant="standard"
                                              label="Search Model | Serial No | Inventory ID"
                                              placeholder="Search Model | Serial No | Inventory ID"
                                              InputProps={{
                                                ...params.InputProps,
                                                readOnly: tradeInventory || !!currentItem,
                                              }}
                                            />
                                          )}
                                        />
                                      );
                                    }}
                                  />
                                </FormControl>

                              )}
                            />
                          </FormControl>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}

                  {!tradeInventory && inventoryid && (
                    <TableRow>
                      <TableCell
                        colspan={4}
                        style={{ textAlign: "left" }}
                      >
                        TYPE
                      </TableCell>
                      <TableCell colspan={3}>
                        <input
                          className="form-width-100"
                          type="text"
                          placeholder="TYPE"
                          style={{ height: "30px" }}
                          value={
                            resolvedType === "misc_product"
                              ? "Misc Product"
                              : resolvedType === "misc_watch"
                                ? "Misc Watch"
                                : "Standard Watch"
                          }
                          readOnly
                        // onChange={(e) =>
                        //   setType(e.target.value)
                        // }
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {!tradeInventory && inventoryid && uiType === "standard_watch" && (
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        style={{ textAlign: "left" }}
                      >
                        MODEL
                      </TableCell>
                      <TableCell colspan={3}>
                        <input
                          className="form-width-100"
                          type="text"
                          placeholder="MODEL"
                          style={{ height: "30px" }}
                          value={tradeModel}
                          readOnly={true}
                        // onChange={(e) =>
                        //   setTradeModel(e.target.value)
                        // }
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {!tradeInventory && inventoryid && resolvedType === "misc_product" && (
                    <TableRow>
                      <TableCell
                        colspan={4}
                        style={{ textAlign: "left" }}
                      >
                        MISC CATEGORY
                      </TableCell>
                      <TableCell colspan={3}>
                        <input
                          className="form-width-100"
                          type="text"
                          placeholder="MISC CATEGORY"
                          style={{ height: "30px" }}
                          value={tradeMiscCategory}
                          readOnly={true}
                        // onChange={(e) =>
                        //   setTradeMiscCategory(e.target.value)
                        // }
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {!tradeInventory && inventoryid &&
                    (resolvedType === "misc_watch" || resolvedType === "misc_product") && (
                      <TableRow>
                        <TableCell
                          colspan={4}
                          style={{ textAlign: "left" }}
                        >
                          MODEL NAME
                        </TableCell>
                        <TableCell colspan={3}>
                          <input
                            className="form-width-100"
                            type="text"
                            placeholder="MODEL NAME"
                            style={{ height: "30px" }}
                            value={tradeModelName}
                            readOnly={true}
                          // onChange={(e) =>
                          //   setTradeModelName(e.target.value)
                          // }
                          />
                        </TableCell>
                      </TableRow>
                    )}
                  {!tradeInventory && inventoryid && (
                    <TableRow>
                      <TableCell
                        colspan={4}
                        style={{ textAlign: "left" }}
                      >
                        SERIAL NUMBER
                      </TableCell>
                      <TableCell colspan={3}>
                        <input
                          className="form-width-100"
                          type="text"
                          placeholder="SERIAL NUMBER"
                          style={{ height: "30px" }}
                          value={tradeSerialNumber}
                          readOnly={true}
                        // onChange={(e) =>
                        //   setTradeSerialNumber(e.target.value)
                        // }
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {!tradeInventory && inventoryid && resolvedType === "misc_product" && (
                    <TableRow>
                      <TableCell
                        colspan={4}
                        style={{ textAlign: "left" }}
                      >
                        MODEL NUMBER
                      </TableCell>
                      <TableCell colspan={3}>
                        <input
                          className="form-width-100"
                          type="text"
                          placeholder="MODEL NUMBER"
                          style={{ height: "30px" }}
                          value={tradeModelNumber}
                          readOnly={true}
                        // onChange={(e) =>
                        //   setTradeModelNumber(e.target.value)
                        // }
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {paymentMethod === "Trade" && tradeInventory && (
                    <>
                      <FormControl fullWidth style={{ marginTop: "15px" }}>
                        <InputLabel
                          htmlFor="component-simple"
                          className="color-BCBCBC"
                        >
                          Type
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={watchType}
                          onChange={(e) => {
                            setWatchType(e.target.value);
                            // handleNonTrade();
                          }}
                          defaultValue="standard_watch"
                          label="Type"

                        >
                          <MenuItem value="standard_watch">Standard Watch</MenuItem>
                          <MenuItem value="misc_watch">Misc Watch</MenuItem>
                          <MenuItem value="misc_product">Misc Product</MenuItem>
                        </Select>
                      </FormControl>

                      {watchType === "standard_watch" &&
                        <>
                          <Input
                            id="model"
                            inputProps={{ type: "text" }}
                            autoComplete={"off"}
                            value={modelNo}
                            onChange={(e) => {
                              handleSearch(e, "modelNumber");
                            }}
                            variant="outline"
                            placeholder="Model"
                            className="form-width-100  form-control searchoption boxwidth"
                            endAdornment={
                              (searchObj?.searchVal?.length > 0) ? (
                                <>
                                  <InputAdornment position="end">
                                    {searchLoading ? <CircularProgress /> : (
                                      <IconButton
                                        onClick={() => {
                                          setAnchorEl(null);
                                          setModelErrorText("");
                                          setPropsModelList([]);
                                          setModel("")
                                          setSearchLoading(false)
                                          setSearchObj((prevState) => ({ ...prevState, searchVal: "", searchText: "", from: 'trade' }));
                                        }}
                                        color="primary"
                                      >
                                        <ClearIcon />
                                      </IconButton>
                                    )}

                                  </InputAdornment>
                                </>
                              ) : null
                            }
                          />
                          <FormHelperText className="error-o">{modelErrorText}</FormHelperText>
                          {searchLoading ? null : (
                            (searchObj?.searchVal?.length > 0 && searchObj?.column === "modelNumber" && propsModelList.length > 0) ?
                              <List className="searchlist MuiPaper-elevation1 inventrysearch" style={{ listStyle: "none" }}>
                                {propsModelList.map((item, idx) => (
                                  <div>
                                    <ListItem
                                      key={idx}
                                      onClick={() => handleSelection(item, "model")}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <ListItemIcon>
                                        <IconButton color="primary">
                                          <img
                                            width="45"
                                            src={item.imagepaths?.images?.toString().split(",")[0]}
                                            alt="Product"
                                          />
                                        </IconButton>
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={item.brandname + " " + item.model}
                                        secondary={item.family}
                                        style={{ marginTop: "25px", marginLeft: "80px" }}
                                      />
                                    </ListItem>
                                    <Divider variant="inset" component="li" />
                                  </div>
                                ))}
                              </List> : null)
                          }
                        </>
                      }

                      {watchType === "misc_product" &&
                        <FormControl fullWidth style={{ marginTop: "15px" }}>
                          <InputLabel
                            htmlFor="component-simple"
                            className="color-BCBCBC"
                          >
                            Misc Category
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            onChange={(e) => setTradeMiscCategory(e.target.value)}
                            defaultValue={tradeMiscCategory}
                            label="Type"
                          >
                            <MenuItem value="watch related accessories">Watch Related Accessories</MenuItem>
                            <MenuItem value="apparel">Apparel</MenuItem>
                            <MenuItem value="watch parts">Watch Parts</MenuItem>
                            <MenuItem value="jewelry">Jewelry</MenuItem>
                            <MenuItem value="stones">Stones</MenuItem>
                            <MenuItem value="hand bags">Hand Bags</MenuItem>
                            <MenuItem value="wallets">Wallets</MenuItem>
                            <MenuItem value="bag related accessories">Bag Related Accessories</MenuItem>
                            <MenuItem value="service watches">Service Watches</MenuItem>
                            <MenuItem value="others">Others</MenuItem>
                          </Select>
                          <FormHelperText className="error-o">{miscCategoryErrorText}</FormHelperText>
                        </FormControl>
                      }

                      {(watchType === "misc_watch" || watchType === "misc_product") &&
                        <FormControl
                          className="form-width-100 margin-t-b-20 margin-p-b-20"
                          style={{ marginTop: "15px" }}
                        >
                          <InputLabel
                            htmlFor="component-simple"
                            className="color-BCBCBC"
                          >
                            Model Name
                          </InputLabel>
                          <Input
                            id="component-simple"
                            value={tradeModelName}
                            onChange={(e) => setTradeModelName(e.target.value)}
                          />
                          <FormHelperText className="error-o"> {modelNameErrorText} </FormHelperText>
                        </FormControl>
                      }
                      {/* {(watchType === "standard_watch" || watchType === "misc_watch") && */}
                      <FormControl
                        className="form-width-100 margin-t-b-20 margin-p-b-20"
                        style={{ marginTop: "15px" }}
                      >
                        <InputLabel
                          htmlFor="component-simple"
                          className="color-BCBCBC"
                          shrink={!!serialNo}
                        >
                          Serial Number
                        </InputLabel>
                        <Input
                          id="component-simple"
                          value={serialNo ?? ""}
                          onChange={onSerialNoChange}
                        />
                        <FormHelperText className="error-o">{serialnoErrorText}</FormHelperText>
                      </FormControl>
                      {/* } */}

                      {watchType === "misc_product" &&
                        <FormControl
                          className="form-width-100 margin-t-b-20 margin-p-b-20"
                          style={{ marginTop: "15px" }}
                        >
                          <InputLabel
                            htmlFor="component-simple"
                            className="color-BCBCBC"
                          >
                            Model Number
                          </InputLabel>
                          <Input
                            id="component-simple"
                            value={tradeModelNumber}
                            onChange={(e) => setTradeModelNumber(e.target.value)}
                          />
                          <FormHelperText className="error-o">{modelNumberErrorText}</FormHelperText>
                        </FormControl>
                      }

                      {/* <FormControl
                      className="form-width-100 margin-t-b-20 margin-p-b-20"
                      style={{ marginTop: "15px" }}
                    >
                      <InputLabel
                        htmlFor="component-simple"
                        className="color-BCBCBC"
                      >
                        Model
                      </InputLabel>
                      <Input
                        id="model"
                        inputProps={{ type: "text" }}
                        autoComplete={"on"}
                        value={modelNo}
                        onChange={(e) => {
                          handleSearch(e, "modelNumber");
                        }}
                      />
                      <FormHelperText className="error-o">
                        {modelErrorText}
                      </FormHelperText>
                    </FormControl>
                    {model && model.length > 0 && (
                      <Popover
                        id={"modelNumber"}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          style: { height: "150px", overflow: "auto" , marginTop: '30px'},
                        }}
                      >
                        {model.map((value, key) => {
                          return (
                            <Typography]'
                              style={{ padding: 10, width: 300 }}
                              onClick={() => {
                                handleSelection(value, "model");
                              }}
                            >
                              {value["model"]}
                            </Typography>
                          );
                        })}
                      </Popover>
                    )} */}
                    </>
                  )}
                </div>
              ) : null}

              {/* {
              // Hemal request removed the Trade from payment status
              paymentStatus && paymentStatus == "Trade" ?
               (
                <div>
                  <FormControl
                    className="form-width-100 margin-t-b-20 margin-p-b-20"
                    style={{ marginTop: "15px" }}
                  >
                    <InputLabel
                      htmlFor="component-simple"
                      className="color-BCBCBC"
                    >
                      Model
                    </InputLabel>
                    <Input
                      id="model"
                      inputProps={{ type: "text" }}
                      autoComplete={"on"}
                      value={modelNo}
                      required
                      onChange={(e) => {
                        handleSearch(e, "modelNumber");
                      }}
                    />
                  </FormControl>
                  {model && model.length > 0 && (
                    <Popover
                      id={"modelNumber"}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      PaperProps={{
                        style: { height: "200px", overflow: "auto" },
                      }}
                    >
                      {model?.slice(0, 15).map((value, key) => {
                        return (
                          <Typography
                            style={{ padding: 10, width: 300 }}
                            onClick={() => {
                              handleSelection(value, "model");
                            }}
                          >
                            {value["model"]}
                          </Typography>
                        );
                      })}
                    </Popover>
                  )}

                  <FormControl
                    className="form-width-100 margin-t-b-20 margin-p-b-20"
                    style={{ marginTop: "15px" }}
                  >
                    <InputLabel
                      htmlFor="component-simple"
                      className="color-BCBCBC"
                    >
                      Serial Number
                    </InputLabel>
                    <Input
                      id="component-simple"
                      value={serialNo}
                      required
                      onChange={onSerialNoChange}
                    />
                  </FormControl>
                  {/* {// <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20" style={{ marginTop: '15px' }}>
                    //    <InputLabel htmlFor="component-simple" className="color-BCBCBC">Description</InputLabel>
                     // <Input id="component-simple"                   
                       // value={description}
                        //onChange={onDescriptionChange}
                      ///>
                    //</FormControl> } 

                  <FormControl
                    className="form-width-100 margin-t-b-20 margin-p-b-20"
                    style={{ marginTop: "15px" }}
                  >
                    {disableAmount || amount !== null ? (
                      <InputLabel
                        htmlFor="component-simple"
                        shrink={true}
                        className="color-BCBCBC"
                      >
                        Amount
                      </InputLabel>
                    ) : (
                      <InputLabel
                        htmlFor="component-simple"
                        className="color-BCBCBC"
                      >
                        Amount
                      </InputLabel>
                    )}
                    <Input
                      id="component-simple"
                      key="amount"
                      type="number"
                      disabled={disableAmount}
                      value={amount}
                      inputProps={{
                        step: "0.01",
                      }}
                      // onInput={(e)=>console.log(parseFloat(e.target.value).toFixed(2))}
                      onChange={onAmountChange}
                    />
                  </FormControl>
                </div>
                    ) : null}  */}

              <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  type="submit"
                  variant="text"
                  // disabled={submitLoading || formInvalid || (paymentStatus === "Partially Paid" && (!amount || !paymentMethod))}
                  disableElevation
                  endIcon={submitLoading ? <CircularProgress style={{ width: 22, height: 22, color: '#fff' }} /> : null}
                  onClick={(e) => {
                    if (submitLoading || isDisabled) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                    handleSubmit(e);
                  }}
                  style={{
                    opacity: (submitLoading || isDisabled) ? 0.5 : 1,
                    color: "white",
                    backgroundColor: "black",
                    marginTop: "20px",
                    marginRight: "10px",
                    cursor: (isDisabled || submitLoading) ? "not-allowed" : "pointer",
                    transition: "0.3s",
                  }}
                >
                  Submit
                </Button>
                &nbsp;
                <Button
                  variant="outlined"
                  onClick={handleCloseModal}
                  style={{
                    background: "#fff",
                    color: "#000",
                    marginTop: "20px",
                    paddingTop: "5 !important",
                    paddingBottom: "5 !important",
                  }}
                >
                  Exit
                </Button>
              </Box>
            </form >
          </Box >
        </Modal >

        <Modal
          open={openInvoiceModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Invoice Type
            </Typography>
            <FormControl fullWidth>
              {/* <InputLabel htmlFor="component-simple" className="color-BCBCBC">
                Invoice Type
              </InputLabel> */}
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                onChange={(e) => setInvoiceType(e.target.value)}
                defaultValue={invoiceType}
                label="Payment Status"
              >
                <MenuItem value="regular_invoice">Regular Invoice</MenuItem>
                <MenuItem value="memo_invoice">Memo Invoice</MenuItem>
              </Select>
              {/* <FormHelperText className="error-o">{this.state.onGenderErrorText}</FormHelperText> */}
            </FormControl>
            <Box style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="submit"
                variant="text"
                style={{
                  background: "#000",
                  color: "#fff",
                  marginTop: "20px",
                  marginRight: "10px",
                }}
                onClick={handleNavigateInvoice}
              >
                Create
              </Button>
              &nbsp;
              <Button
                variant="outlined"
                onClick={handleCloseModal}
                style={{
                  background: "#fff",
                  color: "#000",
                  marginTop: "20px",
                  paddingTop: "5 !important",
                  paddingBottom: "5 !important",
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>
        {
          openPayBackModal && (
            <Modal
              open={openPayBackModal}
              onClose={handleClosePayBackModal}
              aria-labelledby="payback-modal-title"
            >
              <Box sx={style}>
                <Typography id="payback-modal-title" variant="h6" component="h2">
                  Payback
                </Typography>

                <form onSubmit={submitPayBackForm}>
                  <div style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
                    <Typography variant="subtitle2">
                      Total Invoice Amount: ${payBackTotalAmount || "-"}
                    </Typography>
                    <Typography variant="subtitle2">
                      Paid Amount: ${(() => {
                        const total = parseFloat(payBackTotalAmount) || 0;
                        const remaining = parseFloat(payBackRemainingAmount) || 0;
                        // paid = total-remaining
                        const paidVal = total - remaining;
                        return (isNaN(paidVal) ? "-" : paidVal.toFixed(2));
                      })()}
                    </Typography>
                  </div>

                  <FormControl fullWidth style={{ marginTop: "15px" }}>
                    <InputLabel htmlFor="payback-amount" className="color-BCBCBC">
                      Amount
                    </InputLabel>
                    <Input
                      id="payback-amount"
                      type="text"
                      value={payBackAmount}
                      inputProps={{
                        step: any,
                      }}
                      onChange={onPayBackAmountChange}
                    />
                    <FormHelperText className="error-o">
                      {payBackErrAmount}
                    </FormHelperText>
                  </FormControl>

                  <FormControl fullWidth style={{ marginTop: "15px" }}>
                    <FormLabel style={{ color: "#C2BCBC" }}>Payment Date</FormLabel>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        margin="normal"
                        id="payback-date-picker"
                        format="MM/dd/yyyy"
                        value={payBackDate}
                        maxDate={new Date()}
                        onChange={(date, e) => setPayBackDate(e)}
                        isClearable
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        placeholder="MM/DD/YYYY"
                        onPaste={(event) => event.preventDefault()}
                        helperText={""}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>

                  <FormControl fullWidth style={{ marginTop: "15px" }}>
                    <InputLabel htmlFor="payback-method" className="color-BCBCBC">
                      Payment Method
                    </InputLabel>
                    <Select
                      labelId="payback-method-label"
                      id="payback-method"
                      onChange={onPayBackMethodChange}
                      value={payBackMethod}
                      label="Payment Method"
                    >
                      {paymentContactBased?.length > 0 && [...paymentContactBased]
                        .sort((a, b) => a.localeCompare(b))
                        .map((value, index) => (
                          <MenuItem key={index} value={value}>
                            {value}
                          </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText className="error-o">
                      {payBackMethodErrorText}
                    </FormHelperText>
                  </FormControl>

                  <FormControl fullWidth style={{ marginTop: "15px" }}>
                    <InputLabel htmlFor="payback-details" className="color-BCBCBC">
                      Payment Details
                    </InputLabel>
                    <Input
                      id="payback-details"
                      value={payBackDetails}
                      onChange={(e) => setPayBackDetails(e.target.value)}
                    />
                  </FormControl>

                  <FormControl fullWidth style={{ marginTop: "15px" }}>
                    <InputLabel htmlFor="payback-remaining" className="color-BCBCBC">
                      Remaining Amount
                    </InputLabel>
                    <Input
                      id="payback-remaining"
                      readOnly
                      value={(() => {
                        const currentRemaining = parseFloat(payBackRemainingAmount) || 0;
                        const addAmount = parseFloat(payBackAmount);
                        if (payBackAmount && !isNaN(addAmount)) {
                          return (currentRemaining + addAmount).toFixed(2);
                        }
                        return isNaN(currentRemaining) ? "-" : currentRemaining.toFixed(2);
                      })()}
                    />
                  </FormControl>

                  <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                    <Button
                      type="submit"
                      variant="text"
                      endIcon={payBackSubmitLoading ? <CircularProgress style={{ width: 22, height: 22, color: '#fff' }} /> : null}
                      onClick={(e) => {
                        if (isPayBackDisabled || payBackSubmitLoading) {
                          e.preventDefault();
                          e.stopPropagation();
                          return;
                        }
                        handleSubmit(e)
                      }}
                      style={{
                        color: "white",
                        backgroundColor: "black",
                        marginRight: "10px",
                        opacity: (isPayBackDisabled || payBackSubmitLoading) ? 0.5 : 1,
                        cursor: (isPayBackDisabled || payBackSubmitLoading) ? "not-allowed" : "pointer",
                      }}
                    >
                      SUBMIT
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleClosePayBackModal}
                      style={{
                        background: "#fff",
                        color: "#000",
                      }}
                    >
                      EXIT
                    </Button>
                  </Box>
                </form>
              </Box>
            </Modal>
          )
        }
      </div >
    )
  }
  return (
    <ContentWrapper contentView={userDetails && (!userDetails?.planDetails || userDetails?.planDetails === "Noplan") ?
      <div style={{ marginTop: "25px" }}> <UpgradePlan /> </div> : getContentView()} >
    </ContentWrapper>
  );
}

const mapStateToProps = (state) => ({
  invoiceDetails: state.InvoiceList,
  modelList: state.ModelList.modelList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoiceList: (data, callback) => dispatch(invoiceDashboard(data, callback)),
    updatePaymentStatus,
    getPaymentHistory,
    downloadInvoice,
    alldownloadInvoice,
    searchProductsAPI,
    invoiceDataPush: (payload, cb) => dispatch(invoiceDataPush(payload, cb)),
    // searchProducts: (search, userId) =>
    //   dispatch(searchProducts(search, userId)),
  };
};

InvoiceDashboardList.propTypes = {
  modelList: PropTypes.arrayOf(PropTypes.object).isRequired,
  // searchProducts: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceDashboardList);